// // // import React, { useState, useEffect } from "react";
// // // import { FileText, Download, Filter, Eye, X, Clock, AlertTriangle, TrendingUp, BarChart3, Activity, Gauge } from "lucide-react";
// // // import { jsPDF } from "jspdf";

// // // const ReportsView = () => {
// // //   const [reports, setReports] = useState([]);
// // //   const [loading, setLoading] = useState(false);
// // //   const [showFilter, setShowFilter] = useState(false);
// // //   const [filterDate, setFilterDate] = useState("");
// // //   const [filteredReports, setFilteredReports] = useState([]);
// // //   const [selectedReport, setSelectedReport] = useState(null);
// // //   const [isPdfViewing, setIsPdfViewing] = useState(false);
// // //   const [pdfUrl, setPdfUrl] = useState(null);

// // //   // Generate sample data for demonstration
// // //   const generateSampleReports = () => {
// // //     const reports = [];
// // //     const today = new Date();
    
// // //     for (let i = 0; i < 30; i++) {
// // //       const date = new Date(today);
// // //       date.setDate(today.getDate() - i);
      
// // //       // Generate defects for this day
// // //       const defects = [];
// // //       const numDefects = Math.floor(Math.random() * 15) + 5;
      
// // //       for (let j = 0; j < numDefects; j++) {
// // //         const hour = Math.floor(Math.random() * 12) + 6;
// // //         const minute = Math.floor(Math.random() * 60);
// // //         const width = Math.random() < 0.5 
// // //           ? (0.85 + Math.random() * 0.04) // Under spec
// // //           : (1.01 + Math.random() * 0.04); // Over spec
        
// // //         defects.push({
// // //           time: `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`,
// // //           width: width.toFixed(3),
// // //           type: width < 0.9 ? 'Under Spec' : 'Over Spec',
// // //           deviation: Math.abs(width - 0.95).toFixed(3),
// // //           shift: hour < 14 ? '1' : '2'
// // //         });
// // //       }
      
// // //       // Sort defects by time
// // //       defects.sort((a, b) => a.time.localeCompare(b.time));
      
// // //       reports.push({
// // //         id: `RPT-${date.getFullYear()}${(date.getMonth() + 1).toString().padStart(2, '0')}${date.getDate().toString().padStart(2, '0')}`,
// // //         date: date.toISOString(),
// // //         statistics: {
// // //           totalMeasurements: Math.floor(Math.random() * 5000) + 3000,
// // //           totalDefects: defects.length,
// // //           underSpec: defects.filter(d => d.type === 'Under Spec').length,
// // //           overSpec: defects.filter(d => d.type === 'Over Spec').length,
// // //           averageWidth: (0.94 + Math.random() * 0.02).toFixed(3),
// // //           minWidth: (0.85 + Math.random() * 0.03).toFixed(3),
// // //           maxWidth: (1.02 + Math.random() * 0.03).toFixed(3),
// // //           qualityRate: ((1 - defects.length / (Math.floor(Math.random() * 5000) + 3000)) * 100).toFixed(1)
// // //         },
// // //         defects: defects,
// // //         production: {
// // //           line: 'Production Line 1',
// // //           product: 'Plastic Roller Web',
// // //           targetWidth: '0.950',
// // //           tolerance: '±0.050',
// // //           shift: Math.random() > 0.5 ? '1' : '2'
// // //         }
// // //       });
// // //     }
    
// // //     return reports;
// // //   };

// // //   useEffect(() => {
// // //     setLoading(true);
// // //     setTimeout(() => {
// // //       const sampleReports = generateSampleReports();
// // //       setReports(sampleReports);
// // //       setFilteredReports(sampleReports);
// // //       setLoading(false);
// // //     }, 1000);
// // //   }, []);

// // //   const formatDate = (dateString) => {
// // //     const date = new Date(dateString);
// // //     return date.toLocaleDateString('en-GB', {
// // //       day: '2-digit',
// // //       month: '2-digit',
// // //       year: 'numeric'
// // //     });
// // //   };

// // //   const formatTime = (dateString) => {
// // //     const date = new Date(dateString);
// // //     return date.toLocaleTimeString('en-GB', {
// // //       hour: '2-digit',
// // //       minute: '2-digit'
// // //     });
// // //   };

// // //   const handleFilterClick = () => {
// // //     setShowFilter(true);
// // //   };

// // //   const handleFilterClose = () => {
// // //     setShowFilter(false);
// // //     setFilterDate("");
// // //     setFilteredReports(reports);
// // //   };

// // //   const handleFilterKeyDown = (e) => {
// // //     if (e.key === "Enter") {
// // //       const filtered = reports.filter((report) =>
// // //         formatDate(report.date).includes(filterDate)
// // //       );
// // //       setFilteredReports(filtered);
// // //       setShowFilter(false);
// // //     }
// // //   };

// // //   const generatePDF = (report, returnBlob = false) => {
// // //     const doc = new jsPDF();
// // //     const pageWidth = doc.internal.pageSize.width;
// // //     const pageHeight = doc.internal.pageSize.height;
    
// // //     // Colors
// // //     const primaryColor = [14, 165, 233]; // cyan-500
// // //     const darkColor = [15, 23, 42]; // slate-900
// // //     const lightGray = [148, 163, 184]; // slate-400
    
// // //     // Header
// // //     doc.setFillColor(...primaryColor);
// // //     doc.rect(0, 0, pageWidth, 40, 'F');
    
// // //     // Company Logo/Name
// // //     doc.setTextColor(255, 255, 255);
// // //     doc.setFontSize(24);
// // //     doc.setFont("helvetica", "bold");
// // //     doc.text("ALWATANIA PLASTIC", pageWidth / 2, 18, { align: "center" });
    
// // //     doc.setFontSize(12);
// // //     doc.setFont("helvetica", "normal");
// // //     doc.text(`Width Measurement Report - ${formatDate(report.date)}`, pageWidth / 2, 28, { align: "center" });
    
// // //     // Report Info Section
// // //     let yPos = 50;
// // //     doc.setTextColor(...darkColor);
// // //     doc.setFontSize(10);
// // //     doc.setFont("helvetica", "bold");
    
// // //     // Draw info boxes
// // //     const boxWidth = 85;
// // //     const boxHeight = 25;
// // //     const margin = 15;
    
// // //     // First row of boxes
// // //     doc.setDrawColor(...lightGray);
// // //     doc.setLineWidth(0.5);
    
// // //     // Report ID box
// // //     doc.rect(margin, yPos, boxWidth, boxHeight);
// // //     doc.setFont("helvetica", "normal");
// // //     doc.setTextColor(...lightGray);
// // //     doc.text("Report ID", margin + 5, yPos + 8);
// // //     doc.setFont("helvetica", "bold");
// // //     doc.setTextColor(...darkColor);
// // //     doc.text(report.id, margin + 5, yPos + 16);
    
// // //     // Production Line box
// // //     doc.rect(margin + boxWidth + 5, yPos, boxWidth, boxHeight);
// // //     doc.setFont("helvetica", "normal");
// // //     doc.setTextColor(...lightGray);
// // //     doc.text("Production Line", margin + boxWidth + 10, yPos + 8);
// // //     doc.setFont("helvetica", "bold");
// // //     doc.setTextColor(...darkColor);
// // //     doc.text(report.production.line, margin + boxWidth + 10, yPos + 16);
    
// // //     // Second row of boxes
// // //     yPos += 30;
    
// // //     // Product box
// // //     doc.rect(margin, yPos, boxWidth, boxHeight);
// // //     doc.setFont("helvetica", "normal");
// // //     doc.setTextColor(...lightGray);
// // //     doc.text("Product", margin + 5, yPos + 8);
// // //     doc.setFont("helvetica", "bold");
// // //     doc.setTextColor(...darkColor);
// // //     doc.text(report.production.product, margin + 5, yPos + 16);
    
// // //     // Target/Tolerance box
// // //     doc.rect(margin + boxWidth + 5, yPos, boxWidth, boxHeight);
// // //     doc.setFont("helvetica", "normal");
// // //     doc.setTextColor(...lightGray);
// // //     doc.text("Target Width / Tolerance", margin + boxWidth + 10, yPos + 8);
// // //     doc.setFont("helvetica", "bold");
// // //     doc.setTextColor(...darkColor);
// // //     doc.text(`${report.production.targetWidth}m ${report.production.tolerance}m`, margin + boxWidth + 10, yPos + 16);
    
// // //     // Statistics Section
// // //     yPos += 40;
// // //     doc.setFillColor(...primaryColor);
// // //     doc.rect(margin, yPos, pageWidth - 2 * margin, 8, 'F');
// // //     doc.setTextColor(255, 255, 255);
// // //     doc.setFontSize(12);
// // //     doc.setFont("helvetica", "bold");
// // //     doc.text("Production Statistics", margin + 5, yPos + 6);
    
// // //     yPos += 15;
    
// // //     // Statistics grid
// // //     const statBoxWidth = 40;
// // //     const statBoxHeight = 20;
// // //     const statSpacing = 5;
    
// // //     // Draw stat boxes
// // //     const stats = [
// // //       { label: "Total Measurements", value: report.statistics.totalMeasurements.toString(), color: darkColor },
// // //       { label: "Quality Rate", value: `${report.statistics.qualityRate}%`, color: [16, 185, 129] }, // green
// // //       { label: "Total Defects", value: report.statistics.totalDefects.toString(), color: [239, 68, 68] }, // red
// // //       { label: "Average Width", value: `${report.statistics.averageWidth}m`, color: darkColor }
// // //     ];
    
// // //     let xPos = margin;
// // //     stats.forEach(stat => {
// // //       doc.setDrawColor(...lightGray);
// // //       doc.setLineWidth(0.5);
// // //       doc.rect(xPos, yPos, statBoxWidth, statBoxHeight);
      
// // //       doc.setFont("helvetica", "normal");
// // //       doc.setFontSize(8);
// // //       doc.setTextColor(...lightGray);
// // //       doc.text(stat.label, xPos + 2, yPos + 6);
      
// // //       doc.setFont("helvetica", "bold");
// // //       doc.setFontSize(11);
// // //       doc.setTextColor(...stat.color);
// // //       doc.text(stat.value, xPos + statBoxWidth / 2, yPos + 14, { align: "center" });
      
// // //       xPos += statBoxWidth + statSpacing;
// // //     });
    
// // //     // Defects Table
// // //     yPos += 35;
// // //     doc.setFillColor(...primaryColor);
// // //     doc.rect(margin, yPos, pageWidth - 2 * margin, 8, 'F');
// // //     doc.setTextColor(255, 255, 255);
// // //     doc.setFontSize(12);
// // //     doc.setFont("helvetica", "bold");
// // //     doc.text("Defects Timeline", margin + 5, yPos + 6);
    
// // //     yPos += 12;
    
// // //     // Manual Table Drawing
// // //     const tableHeaders = ['Time', 'Width (m)', 'Type', 'Deviation (m)', 'Shift'];
// // //     const tableData = report.defects.map(d => [
// // //       d.time,
// // //       d.width,
// // //       d.type,
// // //       d.deviation,
// // //       `Shift ${d.shift}`
// // //     ]);
    
// // //     // Table configuration
// // //     const colWidths = [30, 30, 35, 35, 30];
// // //     const rowHeight = 8;
// // //     const tableWidth = colWidths.reduce((a, b) => a + b, 0);
// // //     let currentY = yPos;
    
// // //     // Draw table header
// // //     doc.setFillColor(...primaryColor);
// // //     doc.rect(margin, currentY, tableWidth, rowHeight, 'F');
// // //     doc.setTextColor(255, 255, 255);
// // //     doc.setFontSize(10);
// // //     doc.setFont("helvetica", "bold");
    
// // //     let xOffset = margin;
// // //     tableHeaders.forEach((header, index) => {
// // //       doc.text(header, xOffset + 2, currentY + 5.5);
// // //       xOffset += colWidths[index];
// // //     });
    
// // //     currentY += rowHeight;
    
// // //     // Draw table rows
// // //     doc.setFontSize(9);
// // //     tableData.forEach((row, rowIndex) => {
// // //       // Check if we need a new page
// // //       if (currentY > pageHeight - 30) {
// // //         doc.addPage();
// // //         currentY = 20;
        
// // //         // Redraw header on new page
// // //         doc.setFillColor(...primaryColor);
// // //         doc.rect(margin, currentY, tableWidth, rowHeight, 'F');
// // //         doc.setTextColor(255, 255, 255);
// // //         doc.setFontSize(10);
// // //         doc.setFont("helvetica", "bold");
        
// // //         xOffset = margin;
// // //         tableHeaders.forEach((header, index) => {
// // //           doc.text(header, xOffset + 2, currentY + 5.5);
// // //           xOffset += colWidths[index];
// // //         });
        
// // //         currentY += rowHeight;
// // //         doc.setFontSize(9);
// // //       }
      
// // //       // Alternate row background
// // //       if (rowIndex % 2 === 0) {
// // //         doc.setFillColor(248, 250, 252);
// // //         doc.rect(margin, currentY, tableWidth, rowHeight, 'F');
// // //       }
      
// // //       // Draw row border
// // //       doc.setDrawColor(...lightGray);
// // //       doc.setLineWidth(0.1);
// // //       doc.rect(margin, currentY, tableWidth, rowHeight);
      
// // //       // Draw cell content
// // //       xOffset = margin;
// // //       row.forEach((cell, cellIndex) => {
// // //         if (cellIndex === 2) { // Type column
// // //           // Color code the type
// // //           if (cell === 'Over Spec') {
// // //             doc.setTextColor(249, 115, 22); // orange
// // //           } else {
// // //             doc.setTextColor(234, 179, 8); // yellow
// // //           }
// // //           doc.setFont("helvetica", "bold");
// // //         } else {
// // //           doc.setTextColor(...darkColor);
// // //           doc.setFont("helvetica", "normal");
// // //         }
        
// // //         doc.text(cell, xOffset + 2, currentY + 5.5);
// // //         xOffset += colWidths[cellIndex];
// // //       });
      
// // //       currentY += rowHeight;
// // //     });
    
// // //     // Footer
// // //     const finalY = currentY + 10;
// // //     if (finalY < pageHeight - 20) {
// // //       doc.setDrawColor(...lightGray);
// // //       doc.setLineWidth(0.5);
// // //       doc.line(margin, pageHeight - 25, pageWidth - margin, pageHeight - 25);
      
// // //       doc.setFont("helvetica", "normal");
// // //       doc.setFontSize(8);
// // //       doc.setTextColor(...lightGray);
// // //       doc.text(`Generated on ${new Date().toLocaleString()}`, margin, pageHeight - 15);
// // //       doc.text("Alwatania Plastic Quality Control Department", pageWidth - margin, pageHeight - 15, { align: "right" });
// // //     }
    
// // //     if (returnBlob) {
// // //       return doc.output('blob');
// // //     }
    
// // //     return doc;
// // //   };

// // //   const handleView = (report) => {
// // //     setSelectedReport(report);
// // //     const pdfBlob = generatePDF(report, true);
// // //     const url = URL.createObjectURL(pdfBlob);
// // //     setPdfUrl(url);
// // //     setIsPdfViewing(true);
// // //   };

// // //   const handleDownload = (report) => {
// // //     const doc = generatePDF(report);
// // //     doc.save(`Width-Report-${formatDate(report.date)}.pdf`);
// // //   };

// // //   const ReportCard = ({ report }) => {
// // //     const isToday = new Date(report.date).toDateString() === new Date().toDateString();
    
// // //     return (
// // //       <div className="bg-slate-900/80 backdrop-blur-xl rounded-xl border border-slate-800 mb-4">
// // //         <div className="p-4">
// // //           <div className="flex items-center justify-between mb-4">
// // //             <div className="flex items-center gap-3">
// // //               <FileText className="h-5 w-5 text-cyan-400" />
// // //               <div>
// // //                 <h3 className="text-white font-semibold">
// // //                   Report for {formatDate(report.date)}
// // //                   {isToday && (
// // //                     <span className="ml-2 px-2 py-0.5 bg-emerald-500/20 text-emerald-400 text-xs rounded-full">
// // //                       Today
// // //                     </span>
// // //                   )}
// // //                 </h3>
// // //                 <p className="text-xs text-slate-400">ID: {report.id}</p>
// // //               </div>
// // //             </div>
            
// // //             <div className="flex gap-2">
// // //               <button
// // //                 onClick={() => handleView(report)}
// // //                 className="p-2 hover:bg-slate-800 rounded-lg transition-colors"
// // //                 title="View Report"
// // //               >
// // //                 <Eye className="h-5 w-5 text-cyan-400" />
// // //               </button>
// // //               <button
// // //                 onClick={() => handleDownload(report)}
// // //                 className="p-2 hover:bg-slate-800 rounded-lg transition-colors"
// // //                 title="Download Report"
// // //               >
// // //                 <Download className="h-5 w-5 text-cyan-400" />
// // //               </button>
// // //             </div>
// // //           </div>
          
// // //           <div className="grid grid-cols-2 gap-4 mb-4">
// // //             <div>
// // //               <p className="text-xs text-slate-400">Date: {formatDate(report.date)}</p>
// // //               <p className="text-xs text-slate-400 mt-1">Line: {report.production.line}</p>
// // //             </div>
// // //             <div>
// // //               <p className="text-xs text-slate-400">Shift: {report.production.shift}</p>
// // //               <p className="text-xs text-slate-400 mt-1">Product: {report.production.product}</p>
// // //             </div>
// // //           </div>
          
// // //           <div className="bg-slate-800/50 rounded-lg p-3">
// // //             <div className="grid grid-cols-3 gap-4">
// // //               <div>
// // //                 <p className="text-xs text-slate-400">Total Defects</p>
// // //                 <p className="text-lg font-bold text-red-400">{report.statistics.totalDefects}</p>
// // //               </div>
// // //               <div>
// // //                 <p className="text-xs text-slate-400">Quality Rate</p>
// // //                 <p className="text-lg font-bold text-emerald-400">{report.statistics.qualityRate}%</p>
// // //               </div>
// // //               <div>
// // //                 <p className="text-xs text-slate-400">Measurements</p>
// // //                 <p className="text-lg font-bold text-cyan-400">{report.statistics.totalMeasurements}</p>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     );
// // //   };

// // //   return (
// // //     <div className="h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 p-6 overflow-hidden">
// // //       <div className="h-full flex flex-col">
// // //         {/* Header */}
// // //         <div className="mb-6 flex items-center justify-between">
// // //           <h1 className="text-2xl font-bold text-white">Alwatania Plastic - Width Reports</h1>
          
// // //           <div className="flex items-center gap-4">
// // //             {showFilter && (
// // //               <div className="flex items-center bg-slate-800 rounded-lg px-3 py-2">
// // //                 <input
// // //                   type="text"
// // //                   placeholder="DD/MM/YYYY"
// // //                   value={filterDate}
// // //                   onChange={(e) => setFilterDate(e.target.value)}
// // //                   onKeyDown={handleFilterKeyDown}
// // //                   className="bg-transparent text-white placeholder-slate-400 focus:outline-none w-32"
// // //                 />
// // //                 <button
// // //                   onClick={handleFilterClose}
// // //                   className="ml-2 text-slate-400 hover:text-white"
// // //                 >
// // //                   <X className="h-4 w-4" />
// // //                 </button>
// // //               </div>
// // //             )}
// // //             <button
// // //               onClick={() => {
// // //                 setLoading(true);
// // //                 setTimeout(() => {
// // //                   const sampleReports = generateSampleReports();
// // //                   setReports(sampleReports);
// // //                   setFilteredReports(sampleReports);
// // //                   setLoading(false);
// // //                 }, 1000);
// // //               }}
// // //               className="px-4 py-2 bg-cyan-500 hover:bg-cyan-600 text-white rounded-lg transition-colors"
// // //               disabled={loading}
// // //             >
// // //               {loading ? "Refreshing..." : "Refresh Reports"}
// // //             </button>
// // //             <button
// // //               onClick={handleFilterClick}
// // //               className="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-white rounded-lg transition-colors flex items-center gap-2"
// // //             >
// // //               <Filter className="h-4 w-4" />
// // //               Filter
// // //             </button>
// // //           </div>
// // //         </div>
        
// // //         {/* Reports List */}
// // //         <div className="flex-1 overflow-y-auto pr-2">
// // //           {loading ? (
// // //             <div className="flex items-center justify-center h-full">
// // //               <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-400 mr-3" />
// // //               <span className="text-white">Loading reports...</span>
// // //             </div>
// // //           ) : filteredReports.length === 0 ? (
// // //             <div className="flex flex-col items-center justify-center h-full text-slate-400">
// // //               <FileText className="h-12 w-12 mb-4 opacity-50" />
// // //               <p>No reports available</p>
// // //               <p className="text-sm mt-2">Reports will appear here once generated</p>
// // //             </div>
// // //           ) : (
// // //             <div>
// // //               {filteredReports.map((report) => (
// // //                 <ReportCard key={report.id} report={report} />
// // //               ))}
// // //             </div>
// // //           )}
// // //         </div>
// // //       </div>
      
// // //       {/* PDF Viewer Modal */}
// // //       {isPdfViewing && (
// // //         <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
// // //           <div className="bg-slate-900 rounded-xl w-full max-w-6xl h-[90vh] flex flex-col">
// // //             <div className="flex items-center justify-between p-4 border-b border-slate-800">
// // //               <h2 className="text-lg font-semibold text-white">
// // //                 Width Measurement Report - {selectedReport && formatDate(selectedReport.date)}
// // //               </h2>
// // //               <div className="flex items-center gap-2">
// // //                 <button
// // //                   onClick={() => handleDownload(selectedReport)}
// // //                   className="px-4 py-2 bg-cyan-500 hover:bg-cyan-600 text-white rounded-lg transition-colors flex items-center gap-2"
// // //                 >
// // //                   <Download className="h-4 w-4" />
// // //                   Download PDF
// // //                 </button>
// // //                 <button
// // //                   onClick={() => {
// // //                     setIsPdfViewing(false);
// // //                     if (pdfUrl) {
// // //                       URL.revokeObjectURL(pdfUrl);
// // //                     }
// // //                     setPdfUrl(null);
// // //                     setSelectedReport(null);
// // //                   }}
// // //                   className="p-2 hover:bg-slate-800 rounded-lg transition-colors"
// // //                 >
// // //                   <X className="h-5 w-5 text-slate-400" />
// // //                 </button>
// // //               </div>
// // //             </div>
// // //             <div className="flex-1 bg-slate-800 rounded-b-xl overflow-hidden p-4">
// // //               <iframe
// // //                 src={pdfUrl}
// // //                 className="w-full h-full rounded-lg bg-white"
// // //                 title="PDF Report"
// // //               />
// // //             </div>
// // //           </div>
// // //         </div>
// // //       )}
// // //     </div>
// // //   );
// // // };

// // // export default ReportsView;
// // import React, { useState, useEffect } from "react";
// // import { FileText, Download, Filter, Eye, X, Clock, AlertTriangle, TrendingUp, BarChart3, Activity, Gauge, RefreshCw, Wifi, WifiOff } from "lucide-react";
// // import { jsPDF } from "jspdf";

// // const ReportsView = () => {
// //   const [reports, setReports] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [showFilter, setShowFilter] = useState(false);
// //   const [filterDate, setFilterDate] = useState("");
// //   const [filteredReports, setFilteredReports] = useState([]);
// //   const [selectedReport, setSelectedReport] = useState(null);
// //   const [isPdfViewing, setIsPdfViewing] = useState(false);
// //   const [pdfUrl, setPdfUrl] = useState(null);
// //   const [isConnected, setIsConnected] = useState(false);
// //   const [lastUpdate, setLastUpdate] = useState(null);
  
// //   // API Configuration
// //   const API_URL = "https://oyplm85fk3.execute-api.us-east-1.amazonaws.com/prod/download";
  
// //   // Constants for width specifications
// //   const MIN_WIDTH = 0.9;
// //   const MAX_WIDTH = 1.0;
// //   const TARGET_WIDTH = 0.95;
// //   const TOLERANCE = 0.05;

// //   // Fetch data from API and generate reports
// //   const fetchReportsData = async () => {
// //     setLoading(true);
// //     let allRecords = [];
// //     let token = null;
// //     let attempts = 0;
// //     const maxPages = 10;
    
// //     try {
// //       do {
// //         const params = new URLSearchParams({
// //           format: 'json',
// //           page_size: 1000,
// //           order: 'asc'
// //         });
        
// //         if (token) {
// //           params.append('next_token', token);
// //         }
        
// //         const response = await fetch(`${API_URL}?${params}`);
// //         const data = await response.json();
        
// //         if (data.success && data.data) {
// //           allRecords = [...allRecords, ...data.data];
// //           token = data.metadata?.next_token;
// //           setIsConnected(true);
// //         } else {
// //           break;
// //         }
        
// //         attempts++;
// //       } while (token && attempts < maxPages);
      
// //       // Process data and group by date
// //       const processedData = allRecords.map(record => {
// //         const time = new Date(record.time || record.timestamp);
// //         return {
// //           timestamp: time,
// //           date: time.toISOString().split('T')[0],
// //           time: time.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false }),
// //           width: parseFloat(record.width_meters || record.measure_value || 0),
// //           device_id: record.device_id || 'unknown',
// //           location: record.location || 'unknown',
// //         };
// //       });
      
// //       // Group data by date
// //       const groupedByDate = {};
// //       processedData.forEach(record => {
// //         if (!groupedByDate[record.date]) {
// //           groupedByDate[record.date] = [];
// //         }
// //         groupedByDate[record.date].push(record);
// //       });
      
// //       // Generate reports for each date
// //       const generatedReports = [];
// //       Object.keys(groupedByDate).forEach(date => {
// //         const dayData = groupedByDate[date];
        
// //         // Sort by time
// //         dayData.sort((a, b) => a.timestamp - b.timestamp);
        
// //         // Calculate defects
// //         const defects = dayData
// //           .filter(d => d.width < MIN_WIDTH || d.width > MAX_WIDTH)
// //           .map(d => {
// //             const hour = d.timestamp.getHours();
// //             return {
// //               time: d.time,
// //               width: d.width.toFixed(3),
// //               type: d.width < MIN_WIDTH ? 'Under Spec' : 'Over Spec',
// //               deviation: Math.abs(d.width - TARGET_WIDTH).toFixed(3),
// //               shift: hour >= 6 && hour < 14 ? '1' : hour >= 14 && hour < 22 ? '2' : '3',
// //               device: d.device_id,
// //               location: d.location
// //             };
// //           });
        
// //         // Calculate statistics
// //         const widths = dayData.map(d => d.width);
// //         const underSpec = defects.filter(d => d.type === 'Under Spec').length;
// //         const overSpec = defects.filter(d => d.type === 'Over Spec').length;
// //         const qualityRate = dayData.length > 0 
// //           ? ((dayData.length - defects.length) / dayData.length * 100).toFixed(1)
// //           : "100.0";
        
// //         // Calculate standard deviation
// //         const mean = widths.reduce((a, b) => a + b, 0) / widths.length;
// //         const squaredDiffs = widths.map(v => Math.pow(v - mean, 2));
// //         const avgSquaredDiff = squaredDiffs.reduce((a, b) => a + b, 0) / widths.length;
// //         const stdDev = Math.sqrt(avgSquaredDiff);
        
// //         // Determine shift info based on most common shift in defects or data
// //         let primaryShift = '1';
// //         if (dayData.length > 0) {
// //           const shiftCounts = { '1': 0, '2': 0, '3': 0 };
// //           dayData.forEach(d => {
// //             const hour = d.timestamp.getHours();
// //             if (hour >= 6 && hour < 14) shiftCounts['1']++;
// //             else if (hour >= 14 && hour < 22) shiftCounts['2']++;
// //             else shiftCounts['3']++;
// //           });
// //           primaryShift = Object.keys(shiftCounts).reduce((a, b) => 
// //             shiftCounts[a] > shiftCounts[b] ? a : b
// //           );
// //         }
        
// //         const report = {
// //           id: `RPT-${date.replace(/-/g, '')}`,
// //           date: new Date(date + 'T00:00:00').toISOString(),
// //           statistics: {
// //             totalMeasurements: dayData.length,
// //             totalDefects: defects.length,
// //             underSpec: underSpec,
// //             overSpec: overSpec,
// //             averageWidth: widths.length > 0 
// //               ? (widths.reduce((a, b) => a + b, 0) / widths.length).toFixed(3)
// //               : "0.000",
// //             minWidth: widths.length > 0 ? Math.min(...widths).toFixed(3) : "0.000",
// //             maxWidth: widths.length > 0 ? Math.max(...widths).toFixed(3) : "0.000",
// //             qualityRate: qualityRate,
// //             stdDev: stdDev.toFixed(4)
// //           },
// //           defects: defects,
// //           production: {
// //             line: 'Production Line 1',
// //             product: 'Plastic Roller Web',
// //             targetWidth: TARGET_WIDTH.toFixed(3),
// //             tolerance: `±${TOLERANCE.toFixed(3)}`,
// //             shift: primaryShift,
// //             startTime: dayData.length > 0 ? dayData[0].time : '--:--',
// //             endTime: dayData.length > 0 ? dayData[dayData.length - 1].time : '--:--'
// //           },
// //           rawDataCount: dayData.length
// //         };
        
// //         generatedReports.push(report);
// //       });
      
// //       // Sort reports by date (newest first)
// //       generatedReports.sort((a, b) => new Date(b.date) - new Date(a.date));
      
// //       setReports(generatedReports);
// //       setFilteredReports(generatedReports);
// //       setLastUpdate(new Date());
      
// //     } catch (error) {
// //       console.error('Failed to fetch data:', error);
// //       setIsConnected(false);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchReportsData();
// //   }, []);

// //   const formatDate = (dateString) => {
// //     const date = new Date(dateString);
// //     return date.toLocaleDateString('en-GB', {
// //       day: '2-digit',
// //       month: '2-digit',
// //       year: 'numeric'
// //     });
// //   };

// //   const formatTime = (dateString) => {
// //     const date = new Date(dateString);
// //     return date.toLocaleTimeString('en-GB', {
// //       hour: '2-digit',
// //       minute: '2-digit'
// //     });
// //   };

// //   const handleFilterClick = () => {
// //     setShowFilter(true);
// //   };

// //   const handleFilterClose = () => {
// //     setShowFilter(false);
// //     setFilterDate("");
// //     setFilteredReports(reports);
// //   };

// //   const handleFilterKeyDown = (e) => {
// //     if (e.key === "Enter") {
// //       const filtered = reports.filter((report) =>
// //         formatDate(report.date).includes(filterDate)
// //       );
// //       setFilteredReports(filtered);
// //       setShowFilter(false);
// //     }
// //   };

// //   const generatePDF = (report, returnBlob = false) => {
// //     const doc = new jsPDF();
// //     const pageWidth = doc.internal.pageSize.width;
// //     const pageHeight = doc.internal.pageSize.height;
    
// //     // Colors
// //     const primaryColor = [14, 165, 233]; // cyan-500
// //     const darkColor = [15, 23, 42]; // slate-900
// //     const lightGray = [148, 163, 184]; // slate-400
    
// //     // Header
// //     doc.setFillColor(...primaryColor);
// //     doc.rect(0, 0, pageWidth, 40, 'F');
    
// //     // Company Logo/Name
// //     doc.setTextColor(255, 255, 255);
// //     doc.setFontSize(24);
// //     doc.setFont("helvetica", "bold");
// //     doc.text("ALWATANIA PLASTIC", pageWidth / 2, 18, { align: "center" });
    
// //     doc.setFontSize(12);
// //     doc.setFont("helvetica", "normal");
// //     doc.text(`Width Measurement Report - ${formatDate(report.date)}`, pageWidth / 2, 28, { align: "center" });
    
// //     // Report Info Section
// //     let yPos = 50;
// //     doc.setTextColor(...darkColor);
// //     doc.setFontSize(10);
// //     doc.setFont("helvetica", "bold");
    
// //     // Draw info boxes
// //     const boxWidth = 85;
// //     const boxHeight = 25;
// //     const margin = 15;
    
// //     // First row of boxes
// //     doc.setDrawColor(...lightGray);
// //     doc.setLineWidth(0.5);
    
// //     // Report ID box
// //     doc.rect(margin, yPos, boxWidth, boxHeight);
// //     doc.setFont("helvetica", "normal");
// //     doc.setTextColor(...lightGray);
// //     doc.text("Report ID", margin + 5, yPos + 8);
// //     doc.setFont("helvetica", "bold");
// //     doc.setTextColor(...darkColor);
// //     doc.text(report.id, margin + 5, yPos + 16);
    
// //     // Production Line box
// //     doc.rect(margin + boxWidth + 5, yPos, boxWidth, boxHeight);
// //     doc.setFont("helvetica", "normal");
// //     doc.setTextColor(...lightGray);
// //     doc.text("Production Line", margin + boxWidth + 10, yPos + 8);
// //     doc.setFont("helvetica", "bold");
// //     doc.setTextColor(...darkColor);
// //     doc.text(report.production.line, margin + boxWidth + 10, yPos + 16);
    
// //     // Second row of boxes
// //     yPos += 30;
    
// //     // Product box
// //     doc.rect(margin, yPos, boxWidth, boxHeight);
// //     doc.setFont("helvetica", "normal");
// //     doc.setTextColor(...lightGray);
// //     doc.text("Product", margin + 5, yPos + 8);
// //     doc.setFont("helvetica", "bold");
// //     doc.setTextColor(...darkColor);
// //     doc.text(report.production.product, margin + 5, yPos + 16);
    
// //     // Target/Tolerance box
// //     doc.rect(margin + boxWidth + 5, yPos, boxWidth, boxHeight);
// //     doc.setFont("helvetica", "normal");
// //     doc.setTextColor(...lightGray);
// //     doc.text("Target Width / Tolerance", margin + boxWidth + 10, yPos + 8);
// //     doc.setFont("helvetica", "bold");
// //     doc.setTextColor(...darkColor);
// //     doc.text(`${report.production.targetWidth}m ${report.production.tolerance}m`, margin + boxWidth + 10, yPos + 16);
    
// //     // Third row of boxes
// //     yPos += 30;
    
// //     // Time Range box
// //     doc.rect(margin, yPos, boxWidth, boxHeight);
// //     doc.setFont("helvetica", "normal");
// //     doc.setTextColor(...lightGray);
// //     doc.text("Time Range", margin + 5, yPos + 8);
// //     doc.setFont("helvetica", "bold");
// //     doc.setTextColor(...darkColor);
// //     doc.text(`${report.production.startTime} - ${report.production.endTime}`, margin + 5, yPos + 16);
    
// //     // Primary Shift box
// //     doc.rect(margin + boxWidth + 5, yPos, boxWidth, boxHeight);
// //     doc.setFont("helvetica", "normal");
// //     doc.setTextColor(...lightGray);
// //     doc.text("Primary Shift", margin + boxWidth + 10, yPos + 8);
// //     doc.setFont("helvetica", "bold");
// //     doc.setTextColor(...darkColor);
// //     doc.text(`Shift ${report.production.shift}`, margin + boxWidth + 10, yPos + 16);
    
// //     // Statistics Section
// //     yPos += 40;
// //     doc.setFillColor(...primaryColor);
// //     doc.rect(margin, yPos, pageWidth - 2 * margin, 8, 'F');
// //     doc.setTextColor(255, 255, 255);
// //     doc.setFontSize(12);
// //     doc.setFont("helvetica", "bold");
// //     doc.text("Production Statistics", margin + 5, yPos + 6);
    
// //     yPos += 15;
    
// //     // Statistics grid - two rows
// //     const statBoxWidth = 40;
// //     const statBoxHeight = 20;
// //     const statSpacing = 5;
    
// //     // First row of stats
// //     const statsRow1 = [
// //       { label: "Total Measurements", value: report.statistics.totalMeasurements.toString(), color: darkColor },
// //       { label: "Quality Rate", value: `${report.statistics.qualityRate}%`, color: [16, 185, 129] }, // green
// //       { label: "Total Defects", value: report.statistics.totalDefects.toString(), color: [239, 68, 68] }, // red
// //       { label: "Average Width", value: `${report.statistics.averageWidth}m`, color: darkColor }
// //     ];
    
// //     let xPos = margin;
// //     statsRow1.forEach(stat => {
// //       doc.setDrawColor(...lightGray);
// //       doc.setLineWidth(0.5);
// //       doc.rect(xPos, yPos, statBoxWidth, statBoxHeight);
      
// //       doc.setFont("helvetica", "normal");
// //       doc.setFontSize(8);
// //       doc.setTextColor(...lightGray);
// //       doc.text(stat.label, xPos + 2, yPos + 6);
      
// //       doc.setFont("helvetica", "bold");
// //       doc.setFontSize(11);
// //       doc.setTextColor(...stat.color);
// //       doc.text(stat.value, xPos + statBoxWidth / 2, yPos + 14, { align: "center" });
      
// //       xPos += statBoxWidth + statSpacing;
// //     });
    
// //     // Second row of stats
// //     yPos += statBoxHeight + 5;
// //     const statsRow2 = [
// //       { label: "Min Width", value: `${report.statistics.minWidth}m`, color: darkColor },
// //       { label: "Max Width", value: `${report.statistics.maxWidth}m`, color: darkColor },
// //       { label: "Std Deviation", value: report.statistics.stdDev, color: [168, 85, 247] }, // purple
// //       { label: "Under/Over Spec", value: `${report.statistics.underSpec}/${report.statistics.overSpec}`, color: [251, 146, 60] } // orange
// //     ];
    
// //     xPos = margin;
// //     statsRow2.forEach(stat => {
// //       doc.setDrawColor(...lightGray);
// //       doc.setLineWidth(0.5);
// //       doc.rect(xPos, yPos, statBoxWidth, statBoxHeight);
      
// //       doc.setFont("helvetica", "normal");
// //       doc.setFontSize(8);
// //       doc.setTextColor(...lightGray);
// //       doc.text(stat.label, xPos + 2, yPos + 6);
      
// //       doc.setFont("helvetica", "bold");
// //       doc.setFontSize(11);
// //       doc.setTextColor(...stat.color);
// //       doc.text(stat.value, xPos + statBoxWidth / 2, yPos + 14, { align: "center" });
      
// //       xPos += statBoxWidth + statSpacing;
// //     });
    
// //     // Defects Table
// //     yPos += 35;
    
// //     if (report.defects.length > 0) {
// //       doc.setFillColor(...primaryColor);
// //       doc.rect(margin, yPos, pageWidth - 2 * margin, 8, 'F');
// //       doc.setTextColor(255, 255, 255);
// //       doc.setFontSize(12);
// //       doc.setFont("helvetica", "bold");
// //       doc.text(`Defects Timeline (${report.defects.length} defects found)`, margin + 5, yPos + 6);
      
// //       yPos += 12;
      
// //       // Manual Table Drawing
// //       const tableHeaders = ['Time', 'Width (m)', 'Type', 'Deviation (m)', 'Shift', 'Device'];
// //       const tableData = report.defects.map(d => [
// //         d.time,
// //         d.width,
// //         d.type,
// //         d.deviation,
// //         `Shift ${d.shift}`,
// //         d.device
// //       ]);
      
// //       // Table configuration
// //       const colWidths = [25, 25, 30, 30, 25, 45];
// //       const rowHeight = 8;
// //       const tableWidth = colWidths.reduce((a, b) => a + b, 0);
// //       let currentY = yPos;
      
// //       // Draw table header
// //       doc.setFillColor(...primaryColor);
// //       doc.rect(margin, currentY, tableWidth, rowHeight, 'F');
// //       doc.setTextColor(255, 255, 255);
// //       doc.setFontSize(10);
// //       doc.setFont("helvetica", "bold");
      
// //       let xOffset = margin;
// //       tableHeaders.forEach((header, index) => {
// //         doc.text(header, xOffset + 2, currentY + 5.5);
// //         xOffset += colWidths[index];
// //       });
      
// //       currentY += rowHeight;
      
// //       // Draw table rows
// //       doc.setFontSize(9);
// //       tableData.forEach((row, rowIndex) => {
// //         // Check if we need a new page
// //         if (currentY > pageHeight - 30) {
// //           doc.addPage();
// //           currentY = 20;
          
// //           // Redraw header on new page
// //           doc.setFillColor(...primaryColor);
// //           doc.rect(margin, currentY, tableWidth, rowHeight, 'F');
// //           doc.setTextColor(255, 255, 255);
// //           doc.setFontSize(10);
// //           doc.setFont("helvetica", "bold");
          
// //           xOffset = margin;
// //           tableHeaders.forEach((header, index) => {
// //             doc.text(header, xOffset + 2, currentY + 5.5);
// //             xOffset += colWidths[index];
// //           });
          
// //           currentY += rowHeight;
// //           doc.setFontSize(9);
// //         }
        
// //         // Alternate row background
// //         if (rowIndex % 2 === 0) {
// //           doc.setFillColor(248, 250, 252);
// //           doc.rect(margin, currentY, tableWidth, rowHeight, 'F');
// //         }
        
// //         // Draw row border
// //         doc.setDrawColor(...lightGray);
// //         doc.setLineWidth(0.1);
// //         doc.rect(margin, currentY, tableWidth, rowHeight);
        
// //         // Draw cell content
// //         xOffset = margin;
// //         row.forEach((cell, cellIndex) => {
// //           if (cellIndex === 2) { // Type column
// //             // Color code the type
// //             if (cell === 'Over Spec') {
// //               doc.setTextColor(249, 115, 22); // orange
// //             } else {
// //               doc.setTextColor(234, 179, 8); // yellow
// //             }
// //             doc.setFont("helvetica", "bold");
// //           } else {
// //             doc.setTextColor(...darkColor);
// //             doc.setFont("helvetica", "normal");
// //           }
          
// //           doc.text(cell, xOffset + 2, currentY + 5.5);
// //           xOffset += colWidths[cellIndex];
// //         });
        
// //         currentY += rowHeight;
// //       });
// //     } else {
// //       // No defects message
// //       doc.setFillColor(16, 185, 129, 20); // green with transparency
// //       doc.rect(margin, yPos, pageWidth - 2 * margin, 30, 'F');
// //       doc.setTextColor(16, 185, 129);
// //       doc.setFontSize(14);
// //       doc.setFont("helvetica", "bold");
// //       doc.text("No Defects Found", pageWidth / 2, yPos + 18, { align: "center" });
// //       doc.setFont("helvetica", "normal");
// //       doc.setFontSize(10);
// //       doc.text("All measurements within specification limits", pageWidth / 2, yPos + 25, { align: "center" });
// //     }
    
// //     // Footer
// //     doc.setDrawColor(...lightGray);
// //     doc.setLineWidth(0.5);
// //     doc.line(margin, pageHeight - 25, pageWidth - margin, pageHeight - 25);
    
// //     doc.setFont("helvetica", "normal");
// //     doc.setFontSize(8);
// //     doc.setTextColor(...lightGray);
// //     doc.text(`Generated on ${new Date().toLocaleString()}`, margin, pageHeight - 15);
// //     doc.text("Alwatania Plastic Quality Control Department", pageWidth - margin, pageHeight - 15, { align: "right" });
// //     doc.text(`Data Points: ${report.rawDataCount}`, pageWidth / 2, pageHeight - 15, { align: "center" });
    
// //     if (returnBlob) {
// //       return doc.output('blob');
// //     }
    
// //     return doc;
// //   };

// //   const handleView = (report) => {
// //     setSelectedReport(report);
// //     const pdfBlob = generatePDF(report, true);
// //     const url = URL.createObjectURL(pdfBlob);
// //     setPdfUrl(url);
// //     setIsPdfViewing(true);
// //   };

// //   const handleDownload = (report) => {
// //     const doc = generatePDF(report);
// //     doc.save(`Width-Report-${formatDate(report.date)}.pdf`);
// //   };

// //   const ReportCard = ({ report }) => {
// //     const isToday = new Date(report.date).toDateString() === new Date().toDateString();
// //     const isYesterday = (() => {
// //       const yesterday = new Date();
// //       yesterday.setDate(yesterday.getDate() - 1);
// //       return new Date(report.date).toDateString() === yesterday.toDateString();
// //     })();
    
// //     return (
// //       <div className="bg-slate-900/80 backdrop-blur-xl rounded-xl border border-slate-800 mb-4">
// //         <div className="p-4">
// //           <div className="flex items-center justify-between mb-4">
// //             <div className="flex items-center gap-3">
// //               <FileText className="h-5 w-5 text-cyan-400" />
// //               <div>
// //                 <h3 className="text-white font-semibold">
// //                   Report for {formatDate(report.date)}
// //                   {isToday && (
// //                     <span className="ml-2 px-2 py-0.5 bg-emerald-500/20 text-emerald-400 text-xs rounded-full">
// //                       Today
// //                     </span>
// //                   )}
// //                   {isYesterday && (
// //                     <span className="ml-2 px-2 py-0.5 bg-blue-500/20 text-blue-400 text-xs rounded-full">
// //                       Yesterday
// //                     </span>
// //                   )}
// //                 </h3>
// //                 <p className="text-xs text-slate-400">ID: {report.id}</p>
// //               </div>
// //             </div>
            
// //             <div className="flex gap-2">
// //               <button
// //                 onClick={() => handleView(report)}
// //                 className="p-2 hover:bg-slate-800 rounded-lg transition-colors"
// //                 title="View Report"
// //               >
// //                 <Eye className="h-5 w-5 text-cyan-400" />
// //               </button>
// //               <button
// //                 onClick={() => handleDownload(report)}
// //                 className="p-2 hover:bg-slate-800 rounded-lg transition-colors"
// //                 title="Download Report"
// //               >
// //                 <Download className="h-5 w-5 text-cyan-400" />
// //               </button>
// //             </div>
// //           </div>
          
// //           <div className="grid grid-cols-2 gap-4 mb-4">
// //             <div>
// //               <p className="text-xs text-slate-400">Date: {formatDate(report.date)}</p>
// //               <p className="text-xs text-slate-400 mt-1">Time Range: {report.production.startTime} - {report.production.endTime}</p>
// //             </div>
// //             <div>
// //               <p className="text-xs text-slate-400">Primary Shift: {report.production.shift}</p>
// //               <p className="text-xs text-slate-400 mt-1">Product: {report.production.product}</p>
// //             </div>
// //           </div>
          
// //           <div className="bg-slate-800/50 rounded-lg p-3">
// //             <div className="grid grid-cols-4 gap-4">
// //               <div>
// //                 <p className="text-xs text-slate-400">Total Defects</p>
// //                 <p className="text-lg font-bold text-red-400">{report.statistics.totalDefects}</p>
// //                 <p className="text-xs text-slate-500 mt-0.5">
// //                   {report.statistics.underSpec}↓ {report.statistics.overSpec}↑
// //                 </p>
// //               </div>
// //               <div>
// //                 <p className="text-xs text-slate-400">Quality Rate</p>
// //                 <p className="text-lg font-bold text-emerald-400">{report.statistics.qualityRate}%</p>
// //               </div>
// //               <div>
// //                 <p className="text-xs text-slate-400">Measurements</p>
// //                 <p className="text-lg font-bold text-cyan-400">{report.statistics.totalMeasurements}</p>
// //               </div>
// //               <div>
// //                 <p className="text-xs text-slate-400">Std Dev</p>
// //                 <p className="text-lg font-bold text-purple-400">{report.statistics.stdDev}</p>
// //               </div>
// //             </div>
            
// //             <div className="mt-3 pt-3 border-t border-slate-700 grid grid-cols-3 gap-4 text-xs">
// //               <div>
// //                 <span className="text-slate-400">Min:</span>
// //                 <span className="text-white ml-1 font-mono">{report.statistics.minWidth}m</span>
// //               </div>
// //               <div>
// //                 <span className="text-slate-400">Avg:</span>
// //                 <span className="text-white ml-1 font-mono">{report.statistics.averageWidth}m</span>
// //               </div>
// //               <div>
// //                 <span className="text-slate-400">Max:</span>
// //                 <span className="text-white ml-1 font-mono">{report.statistics.maxWidth}m</span>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     );
// //   };

// //   return (
// //     <div className="h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 p-6 overflow-hidden">
// //       <div className="h-full flex flex-col">
// //         {/* Header */}
// //         <div className="mb-6 flex items-center justify-between">
// //           <h1 className="text-2xl font-bold text-white flex items-center gap-2">
// //             <FileText className="h-6 w-6 text-cyan-400" />
// //             Alwatania Plastic - Width Reports
// //           </h1>
          
// //           <div className="flex items-center gap-4">
// //             {/* Connection Status */}
// //             <div className="flex items-center gap-2">
// //               {isConnected ? (
// //                 <Wifi className="h-4 w-4 text-emerald-400" />
// //               ) : (
// //                 <WifiOff className="h-4 w-4 text-red-400" />
// //               )}
// //               <span className={`text-xs ${isConnected ? 'text-emerald-400' : 'text-red-400'}`}>
// //                 {isConnected ? 'Connected' : 'Offline'}
// //               </span>
// //               {lastUpdate && (
// //                 <span className="text-xs text-slate-500 ml-2">
// //                   Updated: {lastUpdate.toLocaleTimeString()}
// //                 </span>
// //               )}
// //             </div>
            
// //             {showFilter && (
// //               <div className="flex items-center bg-slate-800 rounded-lg px-3 py-2">
// //                 <input
// //                   type="text"
// //                   placeholder="DD/MM/YYYY"
// //                   value={filterDate}
// //                   onChange={(e) => setFilterDate(e.target.value)}
// //                   onKeyDown={handleFilterKeyDown}
// //                   className="bg-transparent text-white placeholder-slate-400 focus:outline-none w-32"
// //                 />
// //                 <button
// //                   onClick={handleFilterClose}
// //                   className="ml-2 text-slate-400 hover:text-white"
// //                 >
// //                   <X className="h-4 w-4" />
// //                 </button>
// //               </div>
// //             )}
// //             <button
// //               onClick={fetchReportsData}
// //               className="p-2 bg-slate-800 hover:bg-slate-700 rounded-lg transition-colors"
// //               disabled={loading}
// //             >
// //               <RefreshCw className={`h-4 w-4 text-white ${loading ? 'animate-spin' : ''}`} />
// //             </button>
// //             <button
// //               onClick={handleFilterClick}
// //               className="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-white rounded-lg transition-colors flex items-center gap-2"
// //             >
// //               <Filter className="h-4 w-4" />
// //               Filter
// //             </button>
// //           </div>
// //         </div>
        
// //         {/* Reports List */}
// //         <div className="flex-1 overflow-y-auto pr-2">
// //           {loading ? (
// //             <div className="flex items-center justify-center h-full">
// //               <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-400 mr-3" />
// //               <span className="text-white">Loading reports from API...</span>
// //             </div>
// //           ) : filteredReports.length === 0 ? (
// //             <div className="flex flex-col items-center justify-center h-full text-slate-400">
// //               <FileText className="h-12 w-12 mb-4 opacity-50" />
// //               <p>No reports available</p>
// //               <p className="text-sm mt-2">No data found in the API for report generation</p>
// //             </div>
// //           ) : (
// //             <div>
// //               <div className="mb-4 p-3 bg-slate-800/50 rounded-lg">
// //                 <p className="text-sm text-slate-300">
// //                   Found <span className="font-bold text-cyan-400">{filteredReports.length}</span> daily reports
// //                   {reports.length > 0 && (
// //                     <span className="ml-2 text-xs text-slate-400">
// //                       ({reports[reports.length - 1].date.split('T')[0]} to {reports[0].date.split('T')[0]})
// //                     </span>
// //                   )}
// //                 </p>
// //               </div>
// //               {filteredReports.map((report) => (
// //                 <ReportCard key={report.id} report={report} />
// //               ))}
// //             </div>
// //           )}
// //         </div>
// //       </div>
      
// //       {/* PDF Viewer Modal */}
// //       {isPdfViewing && (
// //         <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
// //           <div className="bg-slate-900 rounded-xl w-full max-w-6xl h-[90vh] flex flex-col">
// //             <div className="flex items-center justify-between p-4 border-b border-slate-800">
// //               <h2 className="text-lg font-semibold text-white">
// //                 Width Measurement Report - {selectedReport && formatDate(selectedReport.date)}
// //               </h2>
// //               <div className="flex items-center gap-2">
// //                 <button
// //                   onClick={() => handleDownload(selectedReport)}
// //                   className="px-4 py-2 bg-cyan-500 hover:bg-cyan-600 text-white rounded-lg transition-colors flex items-center gap-2"
// //                 >
// //                   <Download className="h-4 w-4" />
// //                   Download PDF
// //                 </button>
// //                 <button
// //                   onClick={() => {
// //                     setIsPdfViewing(false);
// //                     if (pdfUrl) {
// //                       URL.revokeObjectURL(pdfUrl);
// //                     }
// //                     setPdfUrl(null);
// //                     setSelectedReport(null);
// //                   }}
// //                   className="p-2 hover:bg-slate-800 rounded-lg transition-colors"
// //                 >
// //                   <X className="h-5 w-5 text-slate-400" />
// //                 </button>
// //               </div>
// //             </div>
// //             <div className="flex-1 bg-slate-800 rounded-b-xl overflow-hidden p-4">
// //               <iframe
// //                 src={pdfUrl}
// //                 className="w-full h-full rounded-lg bg-white"
// //                 title="PDF Report"
// //               />
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default ReportsView;
// import React, { useState, useEffect } from "react";
// import { FileText, Download, Filter, Eye, X, Clock, AlertTriangle, TrendingUp, BarChart3, Activity, Gauge, RefreshCw, Wifi, WifiOff, Package } from "lucide-react";
// import { jsPDF } from "jspdf";
// import { MATERIAL_SPECIFICATIONS, getMaterialSpecs, getDefectType } from '../../Materialspecs';

// const ReportsView = () => {
//   const [reports, setReports] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showFilter, setShowFilter] = useState(false);
//   const [filterDate, setFilterDate] = useState("");
//   const [filteredReports, setFilteredReports] = useState([]);
//   const [selectedReport, setSelectedReport] = useState(null);
//   const [isPdfViewing, setIsPdfViewing] = useState(false);
//   const [pdfUrl, setPdfUrl] = useState(null);
//   const [isConnected, setIsConnected] = useState(false);
//   const [lastUpdate, setLastUpdate] = useState(null);
  
//   // API Configuration
//   const API_URL = "https://oyplm85fk3.execute-api.us-east-1.amazonaws.com/prod/download";

//   // Fetch data from API and generate reports
//   const fetchReportsData = async () => {
//     setLoading(true);
//     let allRecords = [];
//     let token = null;
//     let attempts = 0;
//     const maxPages = 10;
    
//     try {
//       do {
//         const params = new URLSearchParams({
//           format: 'json',
//           page_size: 1000,
//           order: 'asc'
//         });
        
//         if (token) {
//           params.append('next_token', token);
//         }
        
//         const response = await fetch(`${API_URL}?${params}`);
//         const data = await response.json();
        
//         if (data.success && data.data) {
//           allRecords = [...allRecords, ...data.data];
//           token = data.metadata?.next_token;
//           setIsConnected(true);
//         } else {
//           break;
//         }
        
//         attempts++;
//       } while (token && attempts < maxPages);
      
//       // Process data with exact material specs
//       const processedData = allRecords.map(record => {
//         const time = new Date(record.time || record.timestamp);
//         const materialCode = record.sensor_type || 'unknown';
//         const specs = getMaterialSpecs(materialCode);
//         const widthInMeters = parseFloat(record.width_meters || record.measure_value || 0);
//         const widthInMM = widthInMeters * 1000;
        
//         // Check defects using exact specifications
//         const isDefect = widthInMM < specs.min || widthInMM > specs.max;
//         const defectInfo = getDefectType(widthInMeters, materialCode);
        
//         return {
//           timestamp: time,
//           date: time.toISOString().split('T')[0],
//           time: time.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false }),
//           width: widthInMeters,
//           widthMM: widthInMM,
//           device_id: record.device_id || 'unknown',
//           location: record.location || 'unknown',
//           material_code: materialCode,
//           material_name: specs.name,
//           specs: specs,
//           isDefect: isDefect,
//           defectType: defectInfo?.type || null,
//           deviation: defectInfo?.deviation || 0
//         };
//       });
      
//       // Group data by date
//       const groupedByDate = {};
//       processedData.forEach(record => {
//         if (!groupedByDate[record.date]) {
//           groupedByDate[record.date] = [];
//         }
//         groupedByDate[record.date].push(record);
//       });
      
//       // Generate reports for each date
//       const generatedReports = [];
//       Object.keys(groupedByDate).forEach(date => {
//         const dayData = groupedByDate[date];
        
//         // Sort by time
//         dayData.sort((a, b) => a.timestamp - b.timestamp);
        
//         // Group by material
//         const materialGroups = {};
//         dayData.forEach(record => {
//           if (!materialGroups[record.material_code]) {
//             materialGroups[record.material_code] = {
//               code: record.material_code,
//               name: record.material_name,
//               specs: record.specs,
//               data: [],
//               defects: []
//             };
//           }
//           materialGroups[record.material_code].data.push(record);
//           if (record.isDefect) {
//             materialGroups[record.material_code].defects.push({
//               time: record.time,
//               timestamp: record.timestamp,
//               widthMM: record.widthMM.toFixed(1),
//               type: record.defectType,
//               deviation: record.deviation.toFixed(1),
//               shift: record.timestamp.getHours() >= 6 && record.timestamp.getHours() < 14 ? '1' : 
//                      record.timestamp.getHours() >= 14 && record.timestamp.getHours() < 22 ? '2' : '3',
//               device: record.device_id,
//               location: record.location,
//               material: record.material_code,
//               material_name: record.material_name,
//               specs: record.specs
//             });
//           }
//         });
        
//         // Calculate overall statistics
//         const widthsMM = dayData.map(d => d.widthMM);
//         const allDefects = dayData.filter(d => d.isDefect);
//         const underSpec = allDefects.filter(d => d.defectType === 'Under Spec').length;
//         const overSpec = allDefects.filter(d => d.defectType === 'Over Spec').length;
//         const qualityRate = dayData.length > 0 
//           ? ((dayData.length - allDefects.length) / dayData.length * 100).toFixed(1)
//           : "100.0";
        
//         // Calculate standard deviation
//         const mean = widthsMM.reduce((a, b) => a + b, 0) / widthsMM.length;
//         const squaredDiffs = widthsMM.map(v => Math.pow(v - mean, 2));
//         const avgSquaredDiff = squaredDiffs.reduce((a, b) => a + b, 0) / widthsMM.length;
//         const stdDev = Math.sqrt(avgSquaredDiff);
        
//         // Get all defects from all materials
//         const allDefectsForReport = [];
//         Object.values(materialGroups).forEach(group => {
//           allDefectsForReport.push(...group.defects);
//         });
        
//         // Sort defects by time
//         allDefectsForReport.sort((a, b) => a.timestamp - b.timestamp);
        
//         // Determine primary material
//         const primaryMaterial = Object.values(materialGroups).reduce((prev, current) => 
//           current.data.length > (prev?.data?.length || 0) ? current : prev
//         );
        
//         const report = {
//           id: `RPT-${date.replace(/-/g, '')}`,
//           date: new Date(date + 'T00:00:00').toISOString(),
//           statistics: {
//             totalMeasurements: dayData.length,
//             totalDefects: allDefects.length,
//             underSpec: underSpec,
//             overSpec: overSpec,
//             averageWidth: widthsMM.length > 0 
//               ? (widthsMM.reduce((a, b) => a + b, 0) / widthsMM.length).toFixed(1)
//               : "0.0",
//             minWidth: widthsMM.length > 0 ? Math.min(...widthsMM).toFixed(1) : "0.0",
//             maxWidth: widthsMM.length > 0 ? Math.max(...widthsMM).toFixed(1) : "0.0",
//             qualityRate: qualityRate,
//             stdDev: stdDev.toFixed(2)
//           },
//           defects: allDefectsForReport,
//           production: {
//             line: 'Production Line 1',
//             product: 'Plastic Roller Web',
//             primaryMaterial: primaryMaterial?.code || 'Mixed',
//             primaryMaterialName: primaryMaterial?.name || 'Mixed Materials',
//             targetWidth: primaryMaterial?.specs?.film_width || 550,
//             minSpec: primaryMaterial?.specs?.min || 500,
//             maxSpec: primaryMaterial?.specs?.max || 600,
//             shift: dayData.length > 0 ? 
//               (dayData[Math.floor(dayData.length/2)].timestamp.getHours() >= 6 && 
//                dayData[Math.floor(dayData.length/2)].timestamp.getHours() < 14 ? '1' : 
//                dayData[Math.floor(dayData.length/2)].timestamp.getHours() >= 14 && 
//                dayData[Math.floor(dayData.length/2)].timestamp.getHours() < 22 ? '2' : '3') : '1',
//             startTime: dayData.length > 0 ? dayData[0].time : '--:--',
//             endTime: dayData.length > 0 ? dayData[dayData.length - 1].time : '--:--'
//           },
//           materialBreakdown: Object.values(materialGroups).map(group => ({
//             code: group.code,
//             name: group.name,
//             count: group.data.length,
//             defects: group.defects.length,
//             qualityRate: group.data.length > 0 
//               ? ((group.data.length - group.defects.length) / group.data.length * 100).toFixed(1)
//               : "100.0",
//             specs: group.specs,
//             avgWidth: group.data.length > 0
//               ? (group.data.reduce((sum, d) => sum + d.widthMM, 0) / group.data.length).toFixed(1)
//               : "0.0"
//           })),
//           rawDataCount: dayData.length
//         };
        
//         generatedReports.push(report);
//       });
      
//       // Sort reports by date (newest first)
//       generatedReports.sort((a, b) => new Date(b.date) - new Date(a.date));
      
//       setReports(generatedReports);
//       setFilteredReports(generatedReports);
//       setLastUpdate(new Date());
      
//     } catch (error) {
//       console.error('Failed to fetch data:', error);
//       setIsConnected(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchReportsData();
//   }, []);

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-GB', {
//       day: '2-digit',
//       month: '2-digit',
//       year: 'numeric'
//     });
//   };

//   // Download defects as CSV
//   const downloadDefectsCSV = (report) => {
//     if (report.defects.length === 0) {
//       alert('No defects found in this report');
//       return;
//     }
    
//     const headers = [
//       'Date',
//       'Time', 
//       'Width (mm)', 
//       'Material Code', 
//       'Material Name',
//       'Min Spec (mm)',
//       'Max Spec (mm)',
//       'Target (mm)',
//       'Defect Type',
//       'Deviation (mm)',
//       'Shift',
//       'Device',
//       'Location'
//     ];
    
//     const rows = report.defects.map(d => [
//       formatDate(report.date),
//       d.time,
//       d.widthMM,
//       d.material,
//       d.material_name,
//       d.specs.min,
//       d.specs.max,
//       d.specs.film_width,
//       d.type,
//       d.deviation,
//       `Shift ${d.shift}`,
//       d.device,
//       d.location
//     ]);
    
//     const csvContent = [
//       headers.join(','),
//       ...rows.map(row => row.map(cell => 
//         typeof cell === 'string' && cell.includes(',') ? `"${cell}"` : cell
//       ).join(','))
//     ].join('\n');
    
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `defects_report_${formatDate(report.date).replace(/\//g, '-')}.csv`;
//     a.click();
//     URL.revokeObjectURL(url);
//   };

//   const generatePDF = (report, returnBlob = false) => {
//     const doc = new jsPDF();
//     const pageWidth = doc.internal.pageSize.width;
//     const pageHeight = doc.internal.pageSize.height;
    
//     // Header
//     doc.setFillColor(14, 165, 233); // cyan-500
//     doc.rect(0, 0, pageWidth, 40, 'F');
    
//     doc.setTextColor(255, 255, 255);
//     doc.setFontSize(24);
//     doc.setFont("helvetica", "bold");
//     doc.text("ALWATANIA PLASTIC", pageWidth / 2, 18, { align: "center" });
    
//     doc.setFontSize(12);
//     doc.setFont("helvetica", "normal");
//     doc.text(`Width Measurement Report - ${formatDate(report.date)}`, pageWidth / 2, 28, { align: "center" });
    
//     // Report Info Section
//     let yPos = 50;
//     doc.setTextColor(15, 23, 42); // dark color
    
//     const boxWidth = 85;
//     const boxHeight = 25;
//     const margin = 15;
    
//     // First row
//     doc.setDrawColor(148, 163, 184); // light gray
//     doc.setLineWidth(0.5);
    
//     doc.rect(margin, yPos, boxWidth, boxHeight);
//     doc.setFont("helvetica", "normal");
//     doc.setTextColor(148, 163, 184);
//     doc.text("Report ID", margin + 5, yPos + 8);
//     doc.setFont("helvetica", "bold");
//     doc.setTextColor(15, 23, 42);
//     doc.text(report.id, margin + 5, yPos + 16);
    
//     doc.rect(margin + boxWidth + 5, yPos, boxWidth, boxHeight);
//     doc.setFont("helvetica", "normal");
//     doc.setTextColor(148, 163, 184);
//     doc.text("Production Line", margin + boxWidth + 10, yPos + 8);
//     doc.setFont("helvetica", "bold");
//     doc.setTextColor(15, 23, 42);
//     doc.text(report.production.line, margin + boxWidth + 10, yPos + 16);
    
//     // Second row - Material
//     yPos += 30;
    
//     doc.rect(margin, yPos, boxWidth * 2 + 5, boxHeight);
//     doc.setFont("helvetica", "normal");
//     doc.setTextColor(148, 163, 184);
//     doc.text("Primary Material", margin + 5, yPos + 8);
//     doc.setFont("helvetica", "bold");
//     doc.setTextColor(15, 23, 42);
//     const materialText = `${report.production.primaryMaterial} - ${report.production.primaryMaterialName.substring(0, 35)}`;
//     doc.text(materialText, margin + 5, yPos + 16);
    
//     // Third row - Specifications
//     yPos += 30;
    
//     doc.rect(margin, yPos, boxWidth, boxHeight);
//     doc.setFont("helvetica", "normal");
//     doc.setTextColor(148, 163, 184);
//     doc.text("Target Width", margin + 5, yPos + 8);
//     doc.setFont("helvetica", "bold");
//     doc.setTextColor(15, 23, 42);
//     doc.text(`${report.production.targetWidth}mm`, margin + 5, yPos + 16);
    
//     doc.rect(margin + boxWidth + 5, yPos, boxWidth, boxHeight);
//     doc.setFont("helvetica", "normal");
//     doc.setTextColor(148, 163, 184);
//     doc.text("Tolerance Range", margin + boxWidth + 10, yPos + 8);
//     doc.setFont("helvetica", "bold");
//     doc.setTextColor(15, 23, 42);
//     doc.text(`${report.production.minSpec}-${report.production.maxSpec}mm`, margin + boxWidth + 10, yPos + 16);
    
//     // Statistics Section
//     yPos += 40;
//     doc.setFillColor(14, 165, 233);
//     doc.rect(margin, yPos, pageWidth - 2 * margin, 8, 'F');
//     doc.setTextColor(255, 255, 255);
//     doc.setFontSize(12);
//     doc.setFont("helvetica", "bold");
//     doc.text("Production Statistics", margin + 5, yPos + 6);
    
//     yPos += 15;
    
//     // Statistics grid
//     const statBoxWidth = 40;
//     const statBoxHeight = 20;
//     const statSpacing = 5;
    
//     const statsRow1 = [
//       { label: "Total Measurements", value: report.statistics.totalMeasurements.toString() },
//       { label: "Quality Rate", value: `${report.statistics.qualityRate}%`, good: true },
//       { label: "Total Defects", value: report.statistics.totalDefects.toString(), bad: true },
//       { label: "Average Width", value: `${report.statistics.averageWidth}mm` }
//     ];
    
//     let xPos = margin;
//     statsRow1.forEach(stat => {
//       doc.setDrawColor(148, 163, 184);
//       doc.setLineWidth(0.5);
//       doc.rect(xPos, yPos, statBoxWidth, statBoxHeight);
      
//       doc.setFont("helvetica", "normal");
//       doc.setFontSize(8);
//       doc.setTextColor(148, 163, 184);
//       doc.text(stat.label, xPos + 2, yPos + 6);
      
//       doc.setFont("helvetica", "bold");
//       doc.setFontSize(11);
//       if (stat.good) {
//         doc.setTextColor(16, 185, 129); // green
//       } else if (stat.bad) {
//         doc.setTextColor(239, 68, 68); // red
//       } else {
//         doc.setTextColor(15, 23, 42); // dark
//       }
//       doc.text(stat.value, xPos + statBoxWidth / 2, yPos + 14, { align: "center" });
      
//       xPos += statBoxWidth + statSpacing;
//     });
    
//     // Material Breakdown
//     yPos += 30;
    
//     if (report.materialBreakdown && report.materialBreakdown.length > 0) {
//       doc.setFillColor(14, 165, 233);
//       doc.rect(margin, yPos, pageWidth - 2 * margin, 8, 'F');
//       doc.setTextColor(255, 255, 255);
//       doc.setFontSize(12);
//       doc.setFont("helvetica", "bold");
//       doc.text("Material Breakdown", margin + 5, yPos + 6);
      
//       yPos += 12;
      
//       // Material table headers
//       const matHeaders = ['Code', 'Name', 'Spec (mm)', 'Count', 'Defects', 'Quality'];
//       const matColWidths = [25, 55, 30, 20, 20, 30];
      
//       doc.setFillColor(14, 165, 233);
//       doc.rect(margin, yPos, matColWidths.reduce((a, b) => a + b, 0), 8, 'F');
//       doc.setTextColor(255, 255, 255);
//       doc.setFontSize(10);
//       doc.setFont("helvetica", "bold");
      
//       let xOffset = margin;
//       matHeaders.forEach((header, index) => {
//         doc.text(header, xOffset + 2, yPos + 5.5);
//         xOffset += matColWidths[index];
//       });
      
//       yPos += 8;
      
//       // Material rows
//       doc.setFontSize(9);
//       report.materialBreakdown.forEach((material, idx) => {
//         if (idx % 2 === 0) {
//           doc.setFillColor(248, 250, 252);
//           doc.rect(margin, yPos, matColWidths.reduce((a, b) => a + b, 0), 8, 'F');
//         }
        
//         doc.setTextColor(15, 23, 42);
//         doc.setFont("helvetica", "normal");
        
//         let xOffset = margin;
//         const rowData = [
//           material.code,
//           material.name.substring(0, 25) + (material.name.length > 25 ? '...' : ''),
//           `${material.specs.min}-${material.specs.max}`,
//           material.count.toString(),
//           material.defects.toString(),
//           `${material.qualityRate}%`
//         ];
        
//         rowData.forEach((cell, cellIndex) => {
//           if (cellIndex === 5 && parseFloat(material.qualityRate) >= 95) {
//             doc.setTextColor(16, 185, 129); // green
//             doc.setFont("helvetica", "bold");
//           } else if (cellIndex === 5 && parseFloat(material.qualityRate) < 90) {
//             doc.setTextColor(239, 68, 68); // red
//             doc.setFont("helvetica", "bold");
//           } else if (cellIndex === 4 && material.defects > 0) {
//             doc.setTextColor(239, 68, 68); // red for defects
//           } else {
//             doc.setTextColor(15, 23, 42);
//             doc.setFont("helvetica", "normal");
//           }
//           doc.text(cell, xOffset + 2, yPos + 5.5);
//           xOffset += matColWidths[cellIndex];
//         });
        
//         yPos += 8;
//       });
//     }
    
//     // Defects Table
//     yPos += 10;
    
//     // Check if we need a new page
//     if (yPos > pageHeight - 60) {
//       doc.addPage();
//       yPos = 20;
//     }
    
//     if (report.defects.length > 0) {
//       doc.setFillColor(14, 165, 233);
//       doc.rect(margin, yPos, pageWidth - 2 * margin, 8, 'F');
//       doc.setTextColor(255, 255, 255);
//       doc.setFontSize(12);
//       doc.setFont("helvetica", "bold");
//       doc.text(`Defects Details (${report.defects.length} defects found)`, margin + 5, yPos + 6);
      
//       yPos += 12;
      
//       // Defects table
//       const tableHeaders = ['Time', 'Width', 'Type', 'Material', 'Shift'];
//       const tableData = report.defects.slice(0, 15).map(d => [
//         d.time,
//         `${d.widthMM}mm`,
//         d.type,
//         d.material,
//         `Shift ${d.shift}`
//       ]);
      
//       const colWidths = [25, 25, 35, 40, 25];
//       const rowHeight = 8;
      
//       // Table header
//       doc.setFillColor(14, 165, 233);
//       doc.rect(margin, yPos, colWidths.reduce((a, b) => a + b, 0), rowHeight, 'F');
//       doc.setTextColor(255, 255, 255);
//       doc.setFontSize(10);
//       doc.setFont("helvetica", "bold");
      
//       let xOffset = margin;
//       tableHeaders.forEach((header, index) => {
//         doc.text(header, xOffset + 2, yPos + 5.5);
//         xOffset += colWidths[index];
//       });
      
//       yPos += rowHeight;
      
//       // Table rows
//       doc.setFontSize(9);
//       tableData.forEach((row, rowIndex) => {
//         if (yPos > pageHeight - 30) {
//           doc.addPage();
//           yPos = 20;
//         }
        
//         if (rowIndex % 2 === 0) {
//           doc.setFillColor(248, 250, 252);
//           doc.rect(margin, yPos, colWidths.reduce((a, b) => a + b, 0), rowHeight, 'F');
//         }
        
//         let xOffset = margin;
//         row.forEach((cell, cellIndex) => {
//           if (cellIndex === 2) { // Type column
//             if (cell === 'Over Spec') {
//               doc.setTextColor(249, 115, 22); // orange
//             } else {
//               doc.setTextColor(234, 179, 8); // yellow
//             }
//             doc.setFont("helvetica", "bold");
//           } else {
//             doc.setTextColor(15, 23, 42);
//             doc.setFont("helvetica", "normal");
//           }
          
//           doc.text(cell, xOffset + 2, yPos + 5.5);
//           xOffset += colWidths[cellIndex];
//         });
        
//         yPos += rowHeight;
//       });
      
//       if (report.defects.length > 15) {
//         doc.setFont("helvetica", "italic");
//         doc.setFontSize(8);
//         doc.setTextColor(148, 163, 184);
//         doc.text(`... and ${report.defects.length - 15} more defects`, pageWidth / 2, yPos + 5, { align: "center" });
//       }
//     } else {
//       doc.setFillColor(16, 185, 129);
//       doc.setFillColor(230, 255, 230); // light green background
//       doc.rect(margin, yPos, pageWidth - 2 * margin, 30, 'F');
//       doc.setTextColor(16, 185, 129);
//       doc.setFontSize(14);
//       doc.setFont("helvetica", "bold");
//       doc.text("No Defects Found", pageWidth / 2, yPos + 18, { align: "center" });
//     }
    
//     // Footer
//     doc.setDrawColor(148, 163, 184);
//     doc.setLineWidth(0.5);
//     doc.line(margin, pageHeight - 25, pageWidth - margin, pageHeight - 25);
    
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(8);
//     doc.setTextColor(148, 163, 184);
//     doc.text(`Generated on ${new Date().toLocaleString()}`, margin, pageHeight - 15);
//     doc.text("Alwatania Plastic Quality Control Department", pageWidth - margin, pageHeight - 15, { align: "right" });
    
//     if (returnBlob) {
//       return doc.output('blob');
//     }
    
//     return doc;
//   };

//   const handleView = (report) => {
//     setSelectedReport(report);
//     const pdfBlob = generatePDF(report, true);
//     const url = URL.createObjectURL(pdfBlob);
//     setPdfUrl(url);
//     setIsPdfViewing(true);
//   };

//   const handleDownload = (report) => {
//     const doc = generatePDF(report);
//     doc.save(`Width-Report-${formatDate(report.date)}.pdf`);
//   };

//   // Handle filter functions
//   const handleFilterClick = () => {
//     setShowFilter(true);
//   };

//   const handleFilterClose = () => {
//     setShowFilter(false);
//     setFilterDate("");
//     setFilteredReports(reports);
//   };

//   const handleFilterKeyDown = (e) => {
//     if (e.key === "Enter") {
//       const filtered = reports.filter((report) =>
//         formatDate(report.date).includes(filterDate)
//       );
//       setFilteredReports(filtered);
//       setShowFilter(false);
//     }
//   };

//   const ReportCard = ({ report }) => {
//     const isToday = new Date(report.date).toDateString() === new Date().toDateString();
//     const isYesterday = (() => {
//       const yesterday = new Date();
//       yesterday.setDate(yesterday.getDate() - 1);
//       return new Date(report.date).toDateString() === yesterday.toDateString();
//     })();
    
//     return (
//       <div className="bg-slate-900/80 backdrop-blur-xl rounded-xl border border-slate-800 mb-4">
//         <div className="p-4">
//           <div className="flex items-center justify-between mb-4">
//             <div className="flex items-center gap-3">
//               <FileText className="h-5 w-5 text-cyan-400" />
//               <div>
//                 <h3 className="text-white font-semibold">
//                   Report for {formatDate(report.date)}
//                   {isToday && (
//                     <span className="ml-2 px-2 py-0.5 bg-emerald-500/20 text-emerald-400 text-xs rounded-full">
//                       Today
//                     </span>
//                   )}
//                   {isYesterday && (
//                     <span className="ml-2 px-2 py-0.5 bg-blue-500/20 text-blue-400 text-xs rounded-full">
//                       Yesterday
//                     </span>
//                   )}
//                 </h3>
//                 <p className="text-xs text-slate-400">ID: {report.id}</p>
//               </div>
//             </div>
            
//             <div className="flex gap-2">
//               <button
//                 onClick={() => handleView(report)}
//                 className="p-2 hover:bg-slate-800 rounded-lg transition-colors"
//                 title="View Report"
//               >
//                 <Eye className="h-5 w-5 text-cyan-400" />
//               </button>
//               <button
//                 onClick={() => handleDownload(report)}
//                 className="p-2 hover:bg-slate-800 rounded-lg transition-colors"
//                 title="Download PDF"
//               >
//                 <Download className="h-5 w-5 text-cyan-400" />
//               </button>
//               <button
//                 onClick={() => downloadDefectsCSV(report)}
//                 className="p-2 hover:bg-slate-800 rounded-lg transition-colors"
//                 title="Download Defects CSV"
//                 disabled={report.defects.length === 0}
//               >
//                 <AlertTriangle className={`h-5 w-5 ${report.defects.length > 0 ? 'text-red-400' : 'text-slate-600'}`} />
//               </button>
//             </div>
//           </div>
          
//           {/* Material Info */}
//           <div className="mb-3 p-2 bg-slate-800/50 rounded-lg flex items-center gap-2">
//             <Package className="h-4 w-4 text-purple-400" />
//             <span className="text-sm text-white font-medium">
//               Material: {report.production.primaryMaterial}
//             </span>
//             <span className="text-xs text-slate-400">
//               ({report.production.primaryMaterialName.substring(0, 30)}...)
//             </span>
//           </div>
          
//           <div className="grid grid-cols-2 gap-4 mb-4">
//             <div>
//               <p className="text-xs text-slate-400">Time Range: {report.production.startTime} - {report.production.endTime}</p>
//               <p className="text-xs text-slate-400 mt-1">Primary Shift: {report.production.shift}</p>
//             </div>
//             <div>
//               <p className="text-xs text-slate-400">Target: {report.production.targetWidth}mm</p>
//               <p className="text-xs text-slate-400 mt-1">Range: {report.production.minSpec}-{report.production.maxSpec}mm</p>
//             </div>
//           </div>
          
//           <div className="bg-slate-800/50 rounded-lg p-3">
//             <div className="grid grid-cols-4 gap-4">
//               <div>
//                 <p className="text-xs text-slate-400">Total Defects</p>
//                 <p className="text-lg font-bold text-red-400">{report.statistics.totalDefects}</p>
//                 <p className="text-xs text-slate-500 mt-0.5">
//                   {report.statistics.underSpec}↓ {report.statistics.overSpec}↑
//                 </p>
//               </div>
//               <div>
//                 <p className="text-xs text-slate-400">Quality Rate</p>
//                 <p className="text-lg font-bold text-emerald-400">{report.statistics.qualityRate}%</p>
//               </div>
//               <div>
//                 <p className="text-xs text-slate-400">Measurements</p>
//                 <p className="text-lg font-bold text-cyan-400">{report.statistics.totalMeasurements}</p>
//               </div>
//               <div>
//                 <p className="text-xs text-slate-400">Avg Width</p>
//                 <p className="text-lg font-bold text-purple-400">{report.statistics.averageWidth}mm</p>
//                 <p className="text-xs text-slate-500">σ={report.statistics.stdDev}</p>
//               </div>
//             </div>
            
//             {/* Material Breakdown Summary */}
//             {report.materialBreakdown && report.materialBreakdown.length > 0 && (
//               <div className="mt-3 pt-3 border-t border-slate-700">
//                 <p className="text-xs text-slate-400 mb-2">Materials Used:</p>
//                 <div className="grid grid-cols-2 gap-2 text-xs">
//                   {report.materialBreakdown.slice(0, 4).map(mat => (
//                     <div key={mat.code} className="flex justify-between">
//                       <span className="text-cyan-400">{mat.code}:</span>
//                       <span className="text-white">{mat.count} samples ({mat.qualityRate}%)</span>
//                     </div>
//                   ))}
//                 </div>
//                 {report.materialBreakdown.length > 4 && (
//                   <p className="text-xs text-slate-500 mt-1">
//                     +{report.materialBreakdown.length - 4} more materials
//                   </p>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 p-6 overflow-hidden">
//       <div className="h-full flex flex-col">
//         {/* Header */}
//         <div className="mb-6 flex items-center justify-between">
//           <h1 className="text-2xl font-bold text-white flex items-center gap-2">
//             <FileText className="h-6 w-6 text-cyan-400" />
//             Alwatania Plastic - Width Reports
//           </h1>
          
//           <div className="flex items-center gap-4">
//             {/* Connection Status */}
//             <div className="flex items-center gap-2">
//               {isConnected ? (
//                 <Wifi className="h-4 w-4 text-emerald-400" />
//               ) : (
//                 <WifiOff className="h-4 w-4 text-red-400" />
//               )}
//               <span className={`text-xs ${isConnected ? 'text-emerald-400' : 'text-red-400'}`}>
//                 {isConnected ? 'Connected' : 'Offline'}
//               </span>
//               {lastUpdate && (
//                 <span className="text-xs text-slate-500 ml-2">
//                   Updated: {lastUpdate.toLocaleTimeString()}
//                 </span>
//               )}
//             </div>
            
//             {showFilter && (
//               <div className="flex items-center bg-slate-800 rounded-lg px-3 py-2">
//                 <input
//                   type="text"
//                   placeholder="DD/MM/YYYY"
//                   value={filterDate}
//                   onChange={(e) => setFilterDate(e.target.value)}
//                   onKeyDown={handleFilterKeyDown}
//                   className="bg-transparent text-white placeholder-slate-400 focus:outline-none w-32"
//                 />
//                 <button
//                   onClick={handleFilterClose}
//                   className="ml-2 text-slate-400 hover:text-white"
//                 >
//                   <X className="h-4 w-4" />
//                 </button>
//               </div>
//             )}
//             <button
//               onClick={fetchReportsData}
//               className="p-2 bg-slate-800 hover:bg-slate-700 rounded-lg transition-colors"
//               disabled={loading}
//             >
//               <RefreshCw className={`h-4 w-4 text-white ${loading ? 'animate-spin' : ''}`} />
//             </button>
//             <button
//               onClick={handleFilterClick}
//               className="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-white rounded-lg transition-colors flex items-center gap-2"
//             >
//               <Filter className="h-4 w-4" />
//               Filter
//             </button>
//           </div>
//         </div>
        
//         {/* Reports List */}
//         <div className="flex-1 overflow-y-auto pr-2">
//           {loading ? (
//             <div className="flex items-center justify-center h-full">
//               <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-400 mr-3" />
//               <span className="text-white">Loading reports from API...</span>
//             </div>
//           ) : filteredReports.length === 0 ? (
//             <div className="flex flex-col items-center justify-center h-full text-slate-400">
//               <FileText className="h-12 w-12 mb-4 opacity-50" />
//               <p>No reports available</p>
//               <p className="text-sm mt-2">No data found in the API for report generation</p>
//             </div>
//           ) : (
//             <div>
//               <div className="mb-4 p-3 bg-slate-800/50 rounded-lg">
//                 <p className="text-sm text-slate-300">
//                   Found <span className="font-bold text-cyan-400">{filteredReports.length}</span> daily reports
//                   {reports.length > 0 && (
//                     <span className="ml-2 text-xs text-slate-400">
//                       ({reports[reports.length - 1].date.split('T')[0]} to {reports[0].date.split('T')[0]})
//                     </span>
//                   )}
//                 </p>
//               </div>
//               {filteredReports.map((report) => (
//                 <ReportCard key={report.id} report={report} />
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
      
//       {/* PDF Viewer Modal */}
//       {isPdfViewing && (
//         <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
//           <div className="bg-slate-900 rounded-xl w-full max-w-6xl h-[90vh] flex flex-col">
//             <div className="flex items-center justify-between p-4 border-b border-slate-800">
//               <h2 className="text-lg font-semibold text-white">
//                 Width Measurement Report - {selectedReport && formatDate(selectedReport.date)}
//               </h2>
//               <div className="flex items-center gap-2">
//                 <button
//                   onClick={() => downloadDefectsCSV(selectedReport)}
//                   className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors flex items-center gap-2"
//                   disabled={selectedReport?.defects?.length === 0}
//                 >
//                   <AlertTriangle className="h-4 w-4" />
//                   Download Defects CSV
//                 </button>
//                 <button
//                   onClick={() => handleDownload(selectedReport)}
//                   className="px-4 py-2 bg-cyan-500 hover:bg-cyan-600 text-white rounded-lg transition-colors flex items-center gap-2"
//                 >
//                   <Download className="h-4 w-4" />
//                   Download PDF
//                 </button>
//                 <button
//                   onClick={() => {
//                     setIsPdfViewing(false);
//                     if (pdfUrl) {
//                       URL.revokeObjectURL(pdfUrl);
//                     }
//                     setPdfUrl(null);
//                     setSelectedReport(null);
//                   }}
//                   className="p-2 hover:bg-slate-800 rounded-lg transition-colors"
//                 >
//                   <X className="h-5 w-5 text-slate-400" />
//                 </button>
//               </div>
//             </div>
//             <div className="flex-1 bg-slate-800 rounded-b-xl overflow-hidden p-4">
//               <iframe
//                 src={pdfUrl}
//                 className="w-full h-full rounded-lg bg-white"
//                 title="PDF Report"
//               />
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ReportsView;
import React, { useState, useEffect } from "react";
import { FileText, Download, Filter, Eye, X, Clock, AlertTriangle, TrendingUp, BarChart3, Activity, Gauge, RefreshCw, Wifi, WifiOff, Package, Calendar } from "lucide-react";
import { jsPDF } from "jspdf";
import { MATERIAL_SPECIFICATIONS, getMaterialSpecs, getDefectType } from '../../Materialspecs';

const ReportsView = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState({ current: 0, total: 0 });
  const [showFilter, setShowFilter] = useState(false);
  const [filterDate, setFilterDate] = useState("");
  const [filteredReports, setFilteredReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [isPdfViewing, setIsPdfViewing] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [availableDates, setAvailableDates] = useState([]);
  
  // API Configuration - Updated endpoints
  const API_BASE = "https://oyplm85fk3.execute-api.us-east-1.amazonaws.com/prod";

  // Fetch available dates first - with fallback to scan recent dates
  const fetchAvailableDates = async () => {
    try {
      // Try the /dates endpoint first
      const response = await fetch(`${API_BASE}/dates`);
      
      if (response.ok) {
        const data = await response.json();
        
        if (data.success && data.dates && data.dates.length > 0) {
          const dates = data.dates.map(d => d.date).sort().reverse();
          setAvailableDates(dates);
          setIsConnected(true);
          console.log('Fetched dates from /dates endpoint:', dates);
          return dates;
        }
      }
      
      // Fallback: scan recent dates manually
      console.log('Falling back to scanning recent dates...');
      return await scanRecentDatesForData();
      
    } catch (error) {
      console.error('Failed to fetch dates from /dates endpoint:', error);
      // Fallback: scan recent dates manually
      return await scanRecentDatesForData();
    }
  };

  // Scan recent dates to find which ones have data
  const scanRecentDatesForData = async () => {
    const foundDates = [];
    const now = new Date();
    
    // Check last 30 days
    for (let i = 0; i < 30; i++) {
      const date = new Date(now);
      date.setDate(date.getDate() - i);
      const dateStr = date.toISOString().split('T')[0];
      
      try {
        // Quick check with large bin to minimize data
        const response = await fetch(`${API_BASE}/download?date=${dateStr}&bin_minutes=1440`);
        
        if (response.ok) {
          const data = await response.json();
          if (data.success && data.data && data.data.length > 0) {
            foundDates.push(dateStr);
            setIsConnected(true);
            console.log(`Found data for ${dateStr}`);
          }
        }
      } catch (e) {
        // Ignore individual date errors
      }
      
      // Small delay to avoid overwhelming API
      await new Promise(resolve => setTimeout(resolve, 100));
    }
    
    setAvailableDates(foundDates);
    
    if (foundDates.length > 0) {
      setIsConnected(true);
    }
    
    return foundDates;
  };

  // Fetch data for a specific date
  const fetchDateData = async (date) => {
    try {
      const url = `${API_BASE}/download?date=${date}&bin_minutes=5`;
      console.log(`Fetching data for ${date}:`, url);
      
      const response = await fetch(url);
      
      if (!response.ok) {
        console.warn(`HTTP ${response.status} for ${date}`);
        return null;
      }
      
      const data = await response.json();
      
      if (data.success && data.data && data.data.length > 0) {
        console.log(`Got ${data.data.length} points for ${date}`);
        setIsConnected(true);
        return data.data;
      }
      
      console.log(`No data for ${date}`);
      return null;
    } catch (error) {
      console.error(`Failed to fetch data for ${date}:`, error);
      return null;
    }
  };

  // Generate report from day data
  const generateReportFromData = (date, rawData) => {
    if (!rawData || rawData.length === 0) return null;

    // Process data with material specs
    const processedData = rawData.map(record => {
      // Parse time - already in KSA timezone from API
      const timeStr = record.time || record.timestamp;
      const time = new Date(timeStr);
      
      const materialCode = record.sensor_type || 'unknown';
      const specs = getMaterialSpecs(materialCode);
      const widthInMeters = parseFloat(record.width_meters || 0);
      const widthInMM = widthInMeters * 1000;
      
      const isDefect = widthInMM < specs.min || widthInMM > specs.max;
      const defectInfo = getDefectType(widthInMeters, materialCode);
      
      return {
        timestamp: time,
        time: time.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false }),
        width: widthInMeters,
        widthMM: widthInMM,
        widthMinMM: record.width_min ? parseFloat(record.width_min) * 1000 : widthInMM,
        widthMaxMM: record.width_max ? parseFloat(record.width_max) * 1000 : widthInMM,
        sampleCount: record.sample_count || 1,
        device_id: record.device_id || 'unknown',
        location: record.location || 'unknown',
        material_code: materialCode,
        material_name: specs.name,
        specs: specs,
        isDefect: isDefect,
        defectType: defectInfo?.type || null,
        deviation: defectInfo?.deviation || 0
      };
    });

    // Sort by time
    processedData.sort((a, b) => a.timestamp - b.timestamp);

    // Group by material
    const materialGroups = {};
    processedData.forEach(record => {
      if (!materialGroups[record.material_code]) {
        materialGroups[record.material_code] = {
          code: record.material_code,
          name: record.material_name,
          specs: record.specs,
          data: [],
          defects: []
        };
      }
      materialGroups[record.material_code].data.push(record);
      if (record.isDefect) {
        materialGroups[record.material_code].defects.push({
          time: record.time,
          timestamp: record.timestamp,
          widthMM: record.widthMM.toFixed(1),
          type: record.defectType,
          deviation: record.deviation.toFixed(1),
          shift: record.timestamp.getHours() >= 6 && record.timestamp.getHours() < 14 ? '1' : 
                 record.timestamp.getHours() >= 14 && record.timestamp.getHours() < 22 ? '2' : '3',
          device: record.device_id,
          location: record.location,
          material: record.material_code,
          material_name: record.material_name,
          specs: record.specs
        });
      }
    });

    // Calculate statistics
    const widthsMM = processedData.map(d => d.widthMM);
    const allDefects = processedData.filter(d => d.isDefect);
    const underSpec = allDefects.filter(d => d.defectType === 'Under Spec').length;
    const overSpec = allDefects.filter(d => d.defectType === 'Over Spec').length;
    const totalSamples = processedData.reduce((sum, d) => sum + (d.sampleCount || 1), 0);
    
    const qualityRate = processedData.length > 0 
      ? ((processedData.length - allDefects.length) / processedData.length * 100).toFixed(1)
      : "100.0";

    // Standard deviation
    const mean = widthsMM.reduce((a, b) => a + b, 0) / widthsMM.length;
    const squaredDiffs = widthsMM.map(v => Math.pow(v - mean, 2));
    const avgSquaredDiff = squaredDiffs.reduce((a, b) => a + b, 0) / widthsMM.length;
    const stdDev = Math.sqrt(avgSquaredDiff);

    // All defects sorted by time
    const allDefectsForReport = [];
    Object.values(materialGroups).forEach(group => {
      allDefectsForReport.push(...group.defects);
    });
    allDefectsForReport.sort((a, b) => a.timestamp - b.timestamp);

    // Primary material
    const primaryMaterial = Object.values(materialGroups).reduce((prev, current) => 
      current.data.length > (prev?.data?.length || 0) ? current : prev
    , null);

    // Create chart data points (downsample if needed)
    const chartData = processedData.length > 100 
      ? processedData.filter((_, i) => i % Math.ceil(processedData.length / 100) === 0)
      : processedData;

    return {
      id: `RPT-${date.replace(/-/g, '')}`,
      date: date,
      timezone: 'GMT+3 (KSA)',
      statistics: {
        totalMeasurements: processedData.length,
        totalSamples: totalSamples,
        totalDefects: allDefects.length,
        underSpec: underSpec,
        overSpec: overSpec,
        averageWidth: widthsMM.length > 0 
          ? (widthsMM.reduce((a, b) => a + b, 0) / widthsMM.length).toFixed(1)
          : "0.0",
        minWidth: widthsMM.length > 0 ? Math.min(...widthsMM).toFixed(1) : "0.0",
        maxWidth: widthsMM.length > 0 ? Math.max(...widthsMM).toFixed(1) : "0.0",
        qualityRate: qualityRate,
        stdDev: stdDev.toFixed(2)
      },
      defects: allDefectsForReport,
      chartData: chartData,
      production: {
        line: 'Production Line 1',
        product: 'Plastic Roller Web',
        primaryMaterial: primaryMaterial?.code || 'Mixed',
        primaryMaterialName: primaryMaterial?.name || 'Mixed Materials',
        targetWidth: primaryMaterial?.specs?.film_width || 550,
        minSpec: primaryMaterial?.specs?.min || 500,
        maxSpec: primaryMaterial?.specs?.max || 600,
        shift: processedData.length > 0 ? 
          (processedData[Math.floor(processedData.length/2)].timestamp.getHours() >= 6 && 
           processedData[Math.floor(processedData.length/2)].timestamp.getHours() < 14 ? '1' : 
           processedData[Math.floor(processedData.length/2)].timestamp.getHours() >= 14 && 
           processedData[Math.floor(processedData.length/2)].timestamp.getHours() < 22 ? '2' : '3') : '1',
        startTime: processedData.length > 0 ? processedData[0].time : '--:--',
        endTime: processedData.length > 0 ? processedData[processedData.length - 1].time : '--:--'
      },
      materialBreakdown: Object.values(materialGroups).map(group => ({
        code: group.code,
        name: group.name,
        count: group.data.length,
        samples: group.data.reduce((sum, d) => sum + (d.sampleCount || 1), 0),
        defects: group.defects.length,
        qualityRate: group.data.length > 0 
          ? ((group.data.length - group.defects.length) / group.data.length * 100).toFixed(1)
          : "100.0",
        specs: group.specs,
        avgWidth: group.data.length > 0
          ? (group.data.reduce((sum, d) => sum + d.widthMM, 0) / group.data.length).toFixed(1)
          : "0.0",
        minWidth: group.data.length > 0
          ? Math.min(...group.data.map(d => d.widthMM)).toFixed(1)
          : "0.0",
        maxWidth: group.data.length > 0
          ? Math.max(...group.data.map(d => d.widthMM)).toFixed(1)
          : "0.0"
      })),
      rawData: processedData
    };
  };

  // Fetch all reports
  const fetchReportsData = async () => {
    setLoading(true);
    setLoadingProgress({ current: 0, total: 0 });
    
    try {
      // Get available dates
      let dates = await fetchAvailableDates();
      
      // If no dates found from API, try scanning recent dates
      if (!dates || dates.length === 0) {
        console.log('No dates from API, scanning recent dates...');
        dates = await scanRecentDatesForData();
      }
      
      if (!dates || dates.length === 0) {
        console.log('No dates found with data');
        setReports([]);
        setFilteredReports([]);
        setLoading(false);
        return;
      }

      console.log(`Found ${dates.length} dates with data:`, dates);
      setLoadingProgress({ current: 0, total: dates.length });

      const generatedReports = [];

      // Fetch data for each date
      for (let i = 0; i < dates.length; i++) {
        const date = dates[i];
        setLoadingProgress({ current: i + 1, total: dates.length });

        const dayData = await fetchDateData(date);
        
        if (dayData && dayData.length > 0) {
          const report = generateReportFromData(date, dayData);
          if (report) {
            generatedReports.push(report);
            console.log(`Generated report for ${date}: ${dayData.length} points`);
          }
        }

        // Small delay to avoid overwhelming the API
        if (i < dates.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 200));
        }
      }

      // Sort by date (newest first)
      generatedReports.sort((a, b) => new Date(b.date) - new Date(a.date));

      setReports(generatedReports);
      setFilteredReports(generatedReports);
      setLastUpdate(new Date());
      
      if (generatedReports.length > 0) {
        setIsConnected(true);
      }

      console.log(`Generated ${generatedReports.length} reports`);

    } catch (error) {
      console.error('Failed to fetch reports:', error);
      setIsConnected(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReportsData();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString + 'T00:00:00');
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const formatDateLong = (dateString) => {
    const date = new Date(dateString + 'T00:00:00');
    return date.toLocaleDateString('en-GB', {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  // Download defects as CSV
  const downloadDefectsCSV = (report) => {
    if (report.defects.length === 0) {
      alert('No defects found in this report');
      return;
    }
    
    const headers = [
      'Date',
      'Time (KSA)', 
      'Width (mm)', 
      'Material Code', 
      'Material Name',
      'Min Spec (mm)',
      'Max Spec (mm)',
      'Target (mm)',
      'Defect Type',
      'Deviation (mm)',
      'Shift',
      'Device',
      'Location'
    ];
    
    const rows = report.defects.map(d => [
      formatDate(report.date),
      d.time,
      d.widthMM,
      d.material,
      d.material_name,
      d.specs.min,
      d.specs.max,
      d.specs.film_width,
      d.type,
      d.deviation,
      `Shift ${d.shift}`,
      d.device,
      d.location
    ]);
    
    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.map(cell => 
        typeof cell === 'string' && cell.includes(',') ? `"${cell}"` : cell
      ).join(','))
    ].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `defects_report_${report.date}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // Download all data as CSV
  const downloadDataCSV = (report) => {
    if (!report.rawData || report.rawData.length === 0) {
      alert('No data found in this report');
      return;
    }
    
    const headers = [
      'Date',
      'Time (KSA)', 
      'Width (mm)',
      'Width Min (mm)',
      'Width Max (mm)',
      'Samples',
      'Material Code', 
      'Material Name',
      'Min Spec (mm)',
      'Max Spec (mm)',
      'Status',
      'Device',
      'Location'
    ];
    
    const rows = report.rawData.map(d => [
      formatDate(report.date),
      d.time,
      d.widthMM.toFixed(1),
      d.widthMinMM.toFixed(1),
      d.widthMaxMM.toFixed(1),
      d.sampleCount,
      d.material_code,
      d.material_name,
      d.specs.min,
      d.specs.max,
      d.isDefect ? d.defectType : 'Normal',
      d.device_id,
      d.location
    ]);
    
    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.map(cell => 
        typeof cell === 'string' && cell.includes(',') ? `"${cell}"` : cell
      ).join(','))
    ].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `width_data_${report.date}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const generatePDF = (report, returnBlob = false) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 15;
    
    // Header
    doc.setFillColor(14, 165, 233);
    doc.rect(0, 0, pageWidth, 40, 'F');
    
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(24);
    doc.setFont("helvetica", "bold");
    doc.text("ALWATANIA PLASTIC", pageWidth / 2, 18, { align: "center" });
    
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(`Width Measurement Report - ${formatDateLong(report.date)}`, pageWidth / 2, 28, { align: "center" });
    doc.setFontSize(10);
    doc.text(`Timezone: ${report.timezone}`, pageWidth / 2, 36, { align: "center" });
    
    let yPos = 50;
    
    // Report Info Section
    const boxWidth = 85;
    const boxHeight = 25;
    
    doc.setDrawColor(148, 163, 184);
    doc.setLineWidth(0.5);
    
    // Row 1: Report ID and Production Line
    doc.rect(margin, yPos, boxWidth, boxHeight);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(148, 163, 184);
    doc.text("Report ID", margin + 5, yPos + 8);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(15, 23, 42);
    doc.text(report.id, margin + 5, yPos + 18);
    
    doc.rect(margin + boxWidth + 5, yPos, boxWidth, boxHeight);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(148, 163, 184);
    doc.text("Time Range (KSA)", margin + boxWidth + 10, yPos + 8);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(15, 23, 42);
    doc.text(`${report.production.startTime} - ${report.production.endTime}`, margin + boxWidth + 10, yPos + 18);
    
    // Row 2: Material
    yPos += 30;
    doc.rect(margin, yPos, boxWidth * 2 + 5, boxHeight);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(148, 163, 184);
    doc.text("Primary Material", margin + 5, yPos + 8);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(15, 23, 42);
    const materialText = `${report.production.primaryMaterial} - ${report.production.primaryMaterialName.substring(0, 40)}`;
    doc.text(materialText, margin + 5, yPos + 18);
    
    // Row 3: Specifications
    yPos += 30;
    doc.rect(margin, yPos, boxWidth, boxHeight);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(148, 163, 184);
    doc.text("Target Width", margin + 5, yPos + 8);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(15, 23, 42);
    doc.text(`${report.production.targetWidth}mm`, margin + 5, yPos + 18);
    
    doc.rect(margin + boxWidth + 5, yPos, boxWidth, boxHeight);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(148, 163, 184);
    doc.text("Tolerance Range", margin + boxWidth + 10, yPos + 8);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(15, 23, 42);
    doc.text(`${report.production.minSpec} - ${report.production.maxSpec}mm`, margin + boxWidth + 10, yPos + 18);
    
    // Statistics Section
    yPos += 40;
    doc.setFillColor(14, 165, 233);
    doc.rect(margin, yPos, pageWidth - 2 * margin, 8, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text("Production Statistics", margin + 5, yPos + 6);
    
    yPos += 15;
    
    // Statistics grid
    const statBoxWidth = 42;
    const statBoxHeight = 22;
    
    const statsRow = [
      { label: "Measurements", value: report.statistics.totalMeasurements.toString() },
      { label: "Samples", value: report.statistics.totalSamples?.toLocaleString() || report.statistics.totalMeasurements.toString() },
      { label: "Quality Rate", value: `${report.statistics.qualityRate}%`, good: true },
      { label: "Defects", value: report.statistics.totalDefects.toString(), bad: report.statistics.totalDefects > 0 }
    ];
    
    let xPos = margin;
    statsRow.forEach(stat => {
      doc.setDrawColor(148, 163, 184);
      doc.setLineWidth(0.5);
      doc.rect(xPos, yPos, statBoxWidth, statBoxHeight);
      
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(148, 163, 184);
      doc.text(stat.label, xPos + 2, yPos + 7);
      
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      if (stat.good) {
        doc.setTextColor(16, 185, 129);
      } else if (stat.bad) {
        doc.setTextColor(239, 68, 68);
      } else {
        doc.setTextColor(15, 23, 42);
      }
      doc.text(stat.value, xPos + statBoxWidth / 2, yPos + 16, { align: "center" });
      
      xPos += statBoxWidth + 3;
    });
    
    // Second row of stats
    yPos += 27;
    xPos = margin;
    
    const statsRow2 = [
      { label: "Average Width", value: `${report.statistics.averageWidth}mm` },
      { label: "Min Width", value: `${report.statistics.minWidth}mm` },
      { label: "Max Width", value: `${report.statistics.maxWidth}mm` },
      { label: "Std Dev (σ)", value: report.statistics.stdDev }
    ];
    
    statsRow2.forEach(stat => {
      doc.setDrawColor(148, 163, 184);
      doc.rect(xPos, yPos, statBoxWidth, statBoxHeight);
      
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(148, 163, 184);
      doc.text(stat.label, xPos + 2, yPos + 7);
      
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.setTextColor(15, 23, 42);
      doc.text(stat.value, xPos + statBoxWidth / 2, yPos + 16, { align: "center" });
      
      xPos += statBoxWidth + 3;
    });
    
    // Chart Section
    yPos += 35;
    doc.setFillColor(14, 165, 233);
    doc.rect(margin, yPos, pageWidth - 2 * margin, 8, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text("Width Measurement Chart (24-Hour View)", margin + 5, yPos + 6);
    
    yPos += 12;
    
    // Draw chart
    const chartWidth = pageWidth - 2 * margin - 10;
    const chartHeight = 45;
    const chartX = margin + 10;
    const chartY = yPos;
    
    // Chart background
    doc.setFillColor(248, 250, 252);
    doc.rect(chartX, chartY, chartWidth, chartHeight, 'F');
    
    // Chart border
    doc.setDrawColor(148, 163, 184);
    doc.setLineWidth(0.5);
    doc.rect(chartX, chartY, chartWidth, chartHeight);
    
    if (report.chartData && report.chartData.length > 0) {
      // Calculate Y scale
      const minSpec = report.production.minSpec;
      const maxSpec = report.production.maxSpec;
      const yMin = Math.min(minSpec - 5, parseFloat(report.statistics.minWidth) - 2);
      const yMax = Math.max(maxSpec + 5, parseFloat(report.statistics.maxWidth) + 2);
      const yRange = yMax - yMin;
      
      // Draw spec limits
      const minSpecY = chartY + chartHeight - ((minSpec - yMin) / yRange * chartHeight);
      const maxSpecY = chartY + chartHeight - ((maxSpec - yMin) / yRange * chartHeight);
      
      // Spec range highlight
      doc.setFillColor(16, 185, 129, 0.1);
      doc.setFillColor(230, 255, 230);
      doc.rect(chartX, maxSpecY, chartWidth, minSpecY - maxSpecY, 'F');
      
      // Spec lines
      doc.setDrawColor(239, 68, 68);
      doc.setLineWidth(0.3);
      doc.setLineDashPattern([2, 2], 0);
      doc.line(chartX, minSpecY, chartX + chartWidth, minSpecY);
      doc.line(chartX, maxSpecY, chartX + chartWidth, maxSpecY);
      doc.setLineDashPattern([], 0);
      
      // Spec labels
      doc.setFontSize(7);
      doc.setTextColor(239, 68, 68);
      doc.text(`${minSpec}`, chartX - 8, minSpecY + 2);
      doc.text(`${maxSpec}`, chartX - 8, maxSpecY + 2);
      
      // Draw data points and line
      doc.setDrawColor(6, 182, 212);
      doc.setLineWidth(0.5);
      
      const points = report.chartData.map((d, i) => {
        const hours = d.timestamp.getHours() + d.timestamp.getMinutes() / 60;
        const x = chartX + (hours / 24) * chartWidth;
        const y = chartY + chartHeight - ((d.widthMM - yMin) / yRange * chartHeight);
        return { x, y, isDefect: d.isDefect };
      });
      
      // Draw line
      for (let i = 1; i < points.length; i++) {
        doc.setDrawColor(6, 182, 212);
        doc.line(points[i-1].x, points[i-1].y, points[i].x, points[i].y);
      }
      
      // Draw points
      points.forEach(p => {
        if (p.isDefect) {
          doc.setFillColor(239, 68, 68);
        } else {
          doc.setFillColor(6, 182, 212);
        }
        doc.circle(p.x, p.y, 0.8, 'F');
      });
      
      // X-axis labels (hours)
      doc.setFontSize(7);
      doc.setTextColor(148, 163, 184);
      for (let h = 0; h <= 24; h += 4) {
        const x = chartX + (h / 24) * chartWidth;
        doc.text(`${h.toString().padStart(2, '0')}:00`, x, chartY + chartHeight + 5, { align: 'center' });
      }
    } else {
      doc.setTextColor(148, 163, 184);
      doc.setFontSize(10);
      doc.text("No chart data available", chartX + chartWidth / 2, chartY + chartHeight / 2, { align: 'center' });
    }
    
    yPos += chartHeight + 15;
    
    // Material Breakdown
    if (report.materialBreakdown && report.materialBreakdown.length > 0) {
      doc.setFillColor(14, 165, 233);
      doc.rect(margin, yPos, pageWidth - 2 * margin, 8, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(11);
      doc.setFont("helvetica", "bold");
      doc.text("Material Breakdown", margin + 5, yPos + 6);
      
      yPos += 12;
      
      const matHeaders = ['Code', 'Name', 'Spec (mm)', 'Count', 'Avg', 'Defects', 'Quality'];
      const matColWidths = [22, 50, 28, 18, 18, 18, 22];
      
      doc.setFillColor(14, 165, 233);
      doc.rect(margin, yPos, matColWidths.reduce((a, b) => a + b, 0), 7, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(8);
      doc.setFont("helvetica", "bold");
      
      let xOffset = margin;
      matHeaders.forEach((header, index) => {
        doc.text(header, xOffset + 2, yPos + 5);
        xOffset += matColWidths[index];
      });
      
      yPos += 7;
      
      doc.setFontSize(8);
      report.materialBreakdown.slice(0, 6).forEach((material, idx) => {
        if (idx % 2 === 0) {
          doc.setFillColor(248, 250, 252);
          doc.rect(margin, yPos, matColWidths.reduce((a, b) => a + b, 0), 7, 'F');
        }
        
        let xOffset = margin;
        const rowData = [
          material.code,
          material.name.substring(0, 22) + (material.name.length > 22 ? '..' : ''),
          `${material.specs.min}-${material.specs.max}`,
          material.count.toString(),
          `${material.avgWidth}`,
          material.defects.toString(),
          `${material.qualityRate}%`
        ];
        
        rowData.forEach((cell, cellIndex) => {
          if (cellIndex === 6 && parseFloat(material.qualityRate) >= 95) {
            doc.setTextColor(16, 185, 129);
            doc.setFont("helvetica", "bold");
          } else if (cellIndex === 5 && material.defects > 0) {
            doc.setTextColor(239, 68, 68);
          } else {
            doc.setTextColor(15, 23, 42);
            doc.setFont("helvetica", "normal");
          }
          doc.text(cell, xOffset + 2, yPos + 5);
          xOffset += matColWidths[cellIndex];
        });
        
        yPos += 7;
      });
    }
    
    // Defects Table - New Page if needed
    if (report.defects.length > 0) {
      if (yPos > pageHeight - 80) {
        doc.addPage();
        yPos = 20;
      } else {
        yPos += 10;
      }
      
      doc.setFillColor(239, 68, 68);
      doc.rect(margin, yPos, pageWidth - 2 * margin, 8, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(11);
      doc.setFont("helvetica", "bold");
      doc.text(`Defects Details (${report.defects.length} defects - ${report.statistics.underSpec}↓ Under / ${report.statistics.overSpec}↑ Over)`, margin + 5, yPos + 6);
      
      yPos += 12;
      
      const tableHeaders = ['Time (KSA)', 'Width', 'Type', 'Material', 'Deviation', 'Shift'];
      const colWidths = [25, 22, 28, 35, 25, 20];
      const rowHeight = 7;
      
      doc.setFillColor(239, 68, 68);
      doc.rect(margin, yPos, colWidths.reduce((a, b) => a + b, 0), rowHeight, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      
      let xOffset = margin;
      tableHeaders.forEach((header, index) => {
        doc.text(header, xOffset + 2, yPos + 5);
        xOffset += colWidths[index];
      });
      
      yPos += rowHeight;
      
      doc.setFontSize(8);
      const maxDefects = Math.min(report.defects.length, 20);
      
      for (let i = 0; i < maxDefects; i++) {
        const d = report.defects[i];
        
        if (yPos > pageHeight - 30) {
          doc.addPage();
          yPos = 20;
        }
        
        if (i % 2 === 0) {
          doc.setFillColor(254, 242, 242);
          doc.rect(margin, yPos, colWidths.reduce((a, b) => a + b, 0), rowHeight, 'F');
        }
        
        const row = [
          d.time,
          `${d.widthMM}mm`,
          d.type,
          d.material,
          `${d.deviation}mm`,
          `Shift ${d.shift}`
        ];
        
        let xOffset = margin;
        row.forEach((cell, cellIndex) => {
          if (cellIndex === 2) {
            if (cell === 'Over Spec') {
              doc.setTextColor(249, 115, 22);
            } else {
              doc.setTextColor(234, 179, 8);
            }
            doc.setFont("helvetica", "bold");
          } else {
            doc.setTextColor(15, 23, 42);
            doc.setFont("helvetica", "normal");
          }
          
          doc.text(cell, xOffset + 2, yPos + 5);
          xOffset += colWidths[cellIndex];
        });
        
        yPos += rowHeight;
      }
      
      if (report.defects.length > maxDefects) {
        doc.setFont("helvetica", "italic");
        doc.setFontSize(8);
        doc.setTextColor(148, 163, 184);
        doc.text(`... and ${report.defects.length - maxDefects} more defects (download CSV for full list)`, pageWidth / 2, yPos + 5, { align: "center" });
      }
    } else {
      yPos += 10;
      doc.setFillColor(220, 252, 231);
      doc.rect(margin, yPos, pageWidth - 2 * margin, 25, 'F');
      doc.setTextColor(16, 185, 129);
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.text("✓ No Defects Found - 100% Quality", pageWidth / 2, yPos + 15, { align: "center" });
    }
    
    // Footer
    const footerY = pageHeight - 20;
    doc.setDrawColor(148, 163, 184);
    doc.setLineWidth(0.5);
    doc.line(margin, footerY - 5, pageWidth - margin, footerY - 5);
    
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(148, 163, 184);
    doc.text(`Generated: ${new Date().toLocaleString('en-GB', { timeZone: 'Asia/Riyadh' })} (KSA)`, margin, footerY);
    doc.text("Alwatania Plastic - Quality Control Department", pageWidth - margin, footerY, { align: "right" });
    
    if (returnBlob) {
      return doc.output('blob');
    }
    
    return doc;
  };

  const handleView = (report) => {
    setSelectedReport(report);
    const pdfBlob = generatePDF(report, true);
    const url = URL.createObjectURL(pdfBlob);
    setPdfUrl(url);
    setIsPdfViewing(true);
  };

  const handleDownload = (report) => {
    const doc = generatePDF(report);
    doc.save(`Width-Report-${report.date}.pdf`);
  };

  const handleFilterClick = () => {
    setShowFilter(true);
  };

  const handleFilterClose = () => {
    setShowFilter(false);
    setFilterDate("");
    setFilteredReports(reports);
  };

  const handleFilterKeyDown = (e) => {
    if (e.key === "Enter") {
      const filtered = reports.filter((report) =>
        report.date.includes(filterDate) || formatDate(report.date).includes(filterDate)
      );
      setFilteredReports(filtered);
      setShowFilter(false);
    }
  };

  const ReportCard = ({ report }) => {
    const today = new Date().toISOString().split('T')[0];
    const yesterday = new Date(Date.now() - 86400000).toISOString().split('T')[0];
    
    const isToday = report.date === today;
    const isYesterday = report.date === yesterday;
    
    return (
      <div className="bg-slate-900/80 backdrop-blur-xl rounded-xl border border-slate-800 mb-4">
        <div className="p-4">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <FileText className="h-5 w-5 text-cyan-400" />
              <div>
                <h3 className="text-white font-semibold flex items-center gap-2">
                  {formatDateLong(report.date)}
                  {isToday && (
                    <span className="px-2 py-0.5 bg-emerald-500/20 text-emerald-400 text-xs rounded-full">
                      Today
                    </span>
                  )}
                  {isYesterday && (
                    <span className="px-2 py-0.5 bg-blue-500/20 text-blue-400 text-xs rounded-full">
                      Yesterday
                    </span>
                  )}
                </h3>
                <p className="text-xs text-slate-400">ID: {report.id} • {report.timezone}</p>
              </div>
            </div>
            
            <div className="flex gap-2">
              <button
                onClick={() => handleView(report)}
                className="p-2 hover:bg-slate-800 rounded-lg transition-colors"
                title="View Report"
              >
                <Eye className="h-5 w-5 text-cyan-400" />
              </button>
              <button
                onClick={() => handleDownload(report)}
                className="p-2 hover:bg-slate-800 rounded-lg transition-colors"
                title="Download PDF"
              >
                <Download className="h-5 w-5 text-cyan-400" />
              </button>
              <button
                onClick={() => downloadDataCSV(report)}
                className="p-2 hover:bg-slate-800 rounded-lg transition-colors"
                title="Download All Data CSV"
              >
                <BarChart3 className="h-5 w-5 text-purple-400" />
              </button>
              <button
                onClick={() => downloadDefectsCSV(report)}
                className="p-2 hover:bg-slate-800 rounded-lg transition-colors"
                title="Download Defects CSV"
                disabled={report.defects.length === 0}
              >
                <AlertTriangle className={`h-5 w-5 ${report.defects.length > 0 ? 'text-red-400' : 'text-slate-600'}`} />
              </button>
            </div>
          </div>
          
          {/* Material & Time Info */}
          <div className="mb-3 p-2 bg-slate-800/50 rounded-lg flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Package className="h-4 w-4 text-purple-400" />
              <span className="text-sm text-white font-medium">
                {report.production.primaryMaterial}
              </span>
              <span className="text-xs text-slate-400">
                ({report.production.primaryMaterialName.substring(0, 25)}...)
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Clock className="h-4 w-4 text-cyan-400" />
              <span className="text-sm text-white">
                {report.production.startTime} - {report.production.endTime}
              </span>
            </div>
          </div>
          
          {/* Specs */}
          <div className="grid grid-cols-3 gap-2 mb-4 text-xs">
            <div className="text-slate-400">Target: <span className="text-white font-medium">{report.production.targetWidth}mm</span></div>
            <div className="text-slate-400">Range: <span className="text-white font-medium">{report.production.minSpec}-{report.production.maxSpec}mm</span></div>
            <div className="text-slate-400">Shift: <span className="text-white font-medium">{report.production.shift}</span></div>
          </div>
          
          {/* Statistics */}
          <div className="bg-slate-800/50 rounded-lg p-3">
            <div className="grid grid-cols-5 gap-3">
              <div>
                <p className="text-xs text-slate-400">Measurements</p>
                <p className="text-lg font-bold text-cyan-400">{report.statistics.totalMeasurements}</p>
                {report.statistics.totalSamples > report.statistics.totalMeasurements && (
                  <p className="text-xs text-yellow-400">{report.statistics.totalSamples.toLocaleString()} samples</p>
                )}
              </div>
              <div>
                <p className="text-xs text-slate-400">Quality Rate</p>
                <p className={`text-lg font-bold ${parseFloat(report.statistics.qualityRate) >= 95 ? 'text-emerald-400' : 'text-yellow-400'}`}>
                  {report.statistics.qualityRate}%
                </p>
              </div>
              <div>
                <p className="text-xs text-slate-400">Defects</p>
                <p className={`text-lg font-bold ${report.statistics.totalDefects > 0 ? 'text-red-400' : 'text-emerald-400'}`}>
                  {report.statistics.totalDefects}
                </p>
                <p className="text-xs text-slate-500">
                  {report.statistics.underSpec}↓ {report.statistics.overSpec}↑
                </p>
              </div>
              <div>
                <p className="text-xs text-slate-400">Avg Width</p>
                <p className="text-lg font-bold text-purple-400">{report.statistics.averageWidth}mm</p>
                <p className="text-xs text-slate-500">σ={report.statistics.stdDev}</p>
              </div>
              <div>
                <p className="text-xs text-slate-400">Range</p>
                <p className="text-sm font-bold text-white">
                  {report.statistics.minWidth} - {report.statistics.maxWidth}mm
                </p>
              </div>
            </div>
            
            {/* Material Breakdown */}
            {report.materialBreakdown && report.materialBreakdown.length > 0 && (
              <div className="mt-3 pt-3 border-t border-slate-700">
                <p className="text-xs text-slate-400 mb-2">Materials ({report.materialBreakdown.length}):</p>
                <div className="grid grid-cols-2 gap-2 text-xs">
                  {report.materialBreakdown.slice(0, 4).map(mat => (
                    <div key={mat.code} className="flex justify-between items-center">
                      <span className="text-cyan-400">{mat.code}:</span>
                      <span className="text-white">
                        {mat.count} pts • avg {mat.avgWidth}mm • 
                        <span className={parseFloat(mat.qualityRate) >= 95 ? 'text-emerald-400' : 'text-yellow-400'}>
                          {mat.qualityRate}%
                        </span>
                      </span>
                    </div>
                  ))}
                </div>
                {report.materialBreakdown.length > 4 && (
                  <p className="text-xs text-slate-500 mt-1">
                    +{report.materialBreakdown.length - 4} more materials
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 p-6 overflow-hidden">
      <div className="h-full flex flex-col">
        {/* Header */}
        <div className="mb-6 flex items-center justify-between">
          <h1 className="text-2xl font-bold text-white flex items-center gap-2">
            <FileText className="h-6 w-6 text-cyan-400" />
            Alwatania Plastic - Daily Reports
            <span className="text-sm font-normal text-slate-400 ml-2">(KSA Timezone GMT+3)</span>
          </h1>
          
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              {isConnected ? (
                <Wifi className="h-4 w-4 text-emerald-400" />
              ) : (
                <WifiOff className="h-4 w-4 text-red-400" />
              )}
              <span className={`text-xs ${isConnected ? 'text-emerald-400' : 'text-red-400'}`}>
                {isConnected ? 'Connected' : 'Offline'}
              </span>
              {lastUpdate && (
                <span className="text-xs text-slate-500 ml-2">
                  Updated: {lastUpdate.toLocaleTimeString()}
                </span>
              )}
            </div>
            
            {showFilter && (
              <div className="flex items-center bg-slate-800 rounded-lg px-3 py-2">
                <input
                  type="text"
                  placeholder="YYYY-MM-DD or DD/MM/YYYY"
                  value={filterDate}
                  onChange={(e) => setFilterDate(e.target.value)}
                  onKeyDown={handleFilterKeyDown}
                  className="bg-transparent text-white placeholder-slate-400 focus:outline-none w-40"
                />
                <button onClick={handleFilterClose} className="ml-2 text-slate-400 hover:text-white">
                  <X className="h-4 w-4" />
                </button>
              </div>
            )}
            <button
              onClick={fetchReportsData}
              className="p-2 bg-slate-800 hover:bg-slate-700 rounded-lg transition-colors"
              disabled={loading}
            >
              <RefreshCw className={`h-4 w-4 text-white ${loading ? 'animate-spin' : ''}`} />
            </button>
            <button
              onClick={handleFilterClick}
              className="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-white rounded-lg transition-colors flex items-center gap-2"
            >
              <Filter className="h-4 w-4" />
              Filter
            </button>
          </div>
        </div>
        
        {/* Reports List */}
        <div className="flex-1 overflow-y-auto pr-2">
          {loading ? (
            <div className="flex flex-col items-center justify-center h-full">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-400 mr-3 mb-4" />
              <span className="text-white mb-2">
                {loadingProgress.total > 0 
                  ? `Loading reports... (${loadingProgress.current}/${loadingProgress.total})` 
                  : 'Scanning for available data...'}
              </span>
              {loadingProgress.total > 0 && (
                <div className="w-64">
                  <div className="flex justify-between text-xs text-slate-400 mb-1">
                    <span>Generating reports...</span>
                    <span>{loadingProgress.current} / {loadingProgress.total}</span>
                  </div>
                  <div className="bg-slate-800 rounded-full h-2">
                    <div 
                      className="bg-cyan-500 rounded-full h-2 transition-all duration-300"
                      style={{ width: `${(loadingProgress.current / loadingProgress.total) * 100}%` }}
                    />
                  </div>
                </div>
              )}
              <p className="text-xs text-slate-500 mt-2">
            Wait a Moment Please              </p>
            </div>
          ) : filteredReports.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-slate-400">
              <FileText className="h-12 w-12 mb-4 opacity-50" />
              <p>No reports available</p>
              <p className="text-sm mt-2">No data found in the API for report generation</p>
            </div>
          ) : (
            <div>
              <div className="mb-4 p-3 bg-slate-800/50 rounded-lg flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Calendar className="h-4 w-4 text-cyan-400" />
                  <p className="text-sm text-slate-300">
                    Found <span className="font-bold text-cyan-400">{filteredReports.length}</span> daily reports
                  </p>
                </div>
                {reports.length > 0 && (
                  <span className="text-xs text-slate-400">
                    {reports[reports.length - 1].date} to {reports[0].date}
                  </span>
                )}
              </div>
              {filteredReports.map((report) => (
                <ReportCard key={report.id} report={report} />
              ))}
            </div>
          )}
        </div>
      </div>
      
      {/* PDF Viewer Modal */}
      {isPdfViewing && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
          <div className="bg-slate-900 rounded-xl w-full max-w-6xl h-[90vh] flex flex-col">
            <div className="flex items-center justify-between p-4 border-b border-slate-800">
              <h2 className="text-lg font-semibold text-white">
                Width Report - {selectedReport && formatDateLong(selectedReport.date)}
              </h2>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => downloadDataCSV(selectedReport)}
                  className="px-4 py-2 bg-purple-500 hover:bg-purple-600 text-white rounded-lg transition-colors flex items-center gap-2"
                >
                  <BarChart3 className="h-4 w-4" />
                  All Data CSV
                </button>
                <button
                  onClick={() => downloadDefectsCSV(selectedReport)}
                  className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors flex items-center gap-2"
                  disabled={selectedReport?.defects?.length === 0}
                >
                  <AlertTriangle className="h-4 w-4" />
                  Defects CSV
                </button>
                <button
                  onClick={() => handleDownload(selectedReport)}
                  className="px-4 py-2 bg-cyan-500 hover:bg-cyan-600 text-white rounded-lg transition-colors flex items-center gap-2"
                >
                  <Download className="h-4 w-4" />
                  Download PDF
                </button>
                <button
                  onClick={() => {
                    setIsPdfViewing(false);
                    if (pdfUrl) URL.revokeObjectURL(pdfUrl);
                    setPdfUrl(null);
                    setSelectedReport(null);
                  }}
                  className="p-2 hover:bg-slate-800 rounded-lg transition-colors"
                >
                  <X className="h-5 w-5 text-slate-400" />
                </button>
              </div>
            </div>
            <div className="flex-1 bg-slate-800 rounded-b-xl overflow-hidden p-4">
              <iframe
                src={pdfUrl}
                className="w-full h-full rounded-lg bg-white"
                title="PDF Report"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportsView;